import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

const translations = {
  en: {
    // Navbar
    navHome: 'Home',
    navHoroscope: 'Horoscope',
    navBirthChart: 'Birth Chart',
    navCompatibility: 'Compatibility',
    navNumerology: 'Numerology',
    navTarot: 'Tarot',
    navVedic: 'Vedic',
    navAskAI: 'Ask AI',
    navMoonPhase: 'Moon Phase',
    navNakshatra: 'Nakshatra',
    navMuhurat: 'Muhurat',
    navRemedies: 'Remedies',
    navPalmReading: 'Palm',
    navTemples: 'Temples',
    navMore: 'More',

    // Footer
    footerBrand: '🕉️ AstroA2Z — AI-Powered Jyotish & Astrology 🪷',
    footerPowered: 'Powered by AI • Rooted in Vedic Wisdom • For guidance and entertainment',

    // Loading
    defaultLoading: 'Consulting the stars...',

    // Home
    heroTagline: 'Your complete AI-powered Jyotish companion. Discover your cosmic blueprint with personalized Rashifal, Kundli, compatibility readings, and Vedic wisdom.',
    heroBtn1: '🪷 Get Your Rashifal',
    heroBtn2: '🪬 Kundli',
    heroBtn3: '✨ Ask AI Astrologer',
    exploreTitle: 'Explore Cosmic Wisdom',
    exploreDesc: 'Everything you need for your Jyotish journey, powered by AI & Vedic knowledge',
    zodiacTitle: 'The 12 Rashis (Zodiac Signs)',
    zodiacDesc: 'Click on your Rashi to get your personalized Rashifal',
    featureDailyHoroscope: 'Daily Horoscope',
    featureDailyHoroscopeDesc: 'Get your daily, weekly, monthly & yearly horoscope powered by AI',
    featureBirthChart: 'Birth Chart',
    featureBirthChartDesc: 'Generate your complete natal birth chart with planetary positions',
    featureCompatibility: 'Compatibility',
    featureCompatibilityDesc: 'Check love compatibility between any two zodiac signs',
    featureNumerology: 'Numerology',
    featureNumerologyDesc: 'Discover your life path number and numerological profile',
    featureTarotReading: 'Tarot Reading',
    featureTarotReadingDesc: 'Get AI-interpreted tarot card readings for guidance',
    featureVedicAstrology: 'Vedic Jyotish',
    featureVedicAstrologyDesc: 'Explore ancient Jyotish — Nakshatra, Dasha, Graha Dosha & Vedic remedies',
    featurePlanetaryTransits: 'Planetary Transits',
    featurePlanetaryTransitsDesc: 'Current planetary movements and their effects on your sign',
    featureChineseZodiac: 'Chinese Zodiac',
    featureChineseZodiacDesc: 'Discover your Chinese zodiac animal and element',
    featureAskAstrologer: 'Ask the Astrologer',
    featureAskAstrologerDesc: 'Chat with our AI astrologer about anything cosmic',

    // Horoscope
    horoscopeTitle: '🔮 Horoscope',
    horoscopeDesc: 'Select your zodiac sign and get your personalized horoscope',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
    readingStars: 'Reading the Stars...',
    getHoroscope: 'Get {period} Horoscope for {sign}',
    loadingHoroscope: 'Reading the {period} cosmic energies for {sign}...',
    horoscopeResult: '🔮 {period} Horoscope — {sign}',

    // Birth Chart
    birthChartTitle: '🪬 Kundli / Birth Chart',
    birthChartDesc: 'Enter your birth details to generate your complete natal chart reading',
    fullName: 'Full Name *',
    dateOfBirth: 'Date of Birth *',
    timeOfBirth: 'Time of Birth',
    placeOfBirth: 'Place of Birth',
    enterFullName: 'Enter your full name',
    cityCountry: 'City, Country',
    generatingChart: 'Generating Chart...',
    generateBirthChart: '🪬 Generate Kundli',
    loadingBirthChart: 'Mapping your celestial blueprint...',
    elementSign: '{element} Sign • Ruled by {ruler}',
    natalChartReading: '🪬 Natal Kundli Reading',
    fillNameDob: 'Please fill in at least your name and date of birth.',

    // Compatibility
    compatibilityTitle: '💕 Compatibility Check',
    compatibilityDesc: 'Discover the cosmic chemistry between two zodiac signs',
    person1Name: 'Person 1 Name (optional)',
    person2Name: 'Person 2 Name (optional)',
    firstPersonName: "First person's name",
    secondPersonName: "Second person's name",
    selectSign1: 'Select Sign 1',
    selectSign2: 'Select Sign 2',
    selectingPerson1: '👆 Selecting for Person 1',
    selectingPerson2: '👆 Selecting for Person 2',
    checkingStars: 'Checking Stars...',
    checkCompatibility: '💕 Check {sign1} & {sign2} Compatibility',
    loadingCompatibility: 'Analyzing the cosmic connection...',
    compatibilityResult: '💕 {sign1} & {sign2} Compatibility',
    selectBothSigns: 'Please select both zodiac signs.',

    // Numerology
    numerologyTitle: '🔢 Numerology',
    numerologyDesc: 'Discover the hidden meaning of numbers in your life',
    calculating: 'Calculating...',
    calculateNumerology: '🔢 Calculate Numerology',
    loadingNumerology: 'Decoding the numbers of your destiny...',
    lifePathNumber: 'Your Life Path Number',
    masterNumber: '✨ Master Number — You carry extraordinary potential!',
    uniqueFrequency: '✨ Your unique vibrational frequency',
    numerologyResult: '🔢 Numerology Reading for {name}',
    enterNameDob: 'Please enter your name and date of birth.',

    // Tarot
    tarotTitle: '🃏 Tarot Reading',
    tarotDesc: 'Draw three cards for Past, Present, and Future guidance',
    tarotIntro: 'Focus on your question or intention, then draw your cards. Leave the question blank for a general life reading.',
    yourQuestion: 'Your Question (optional)',
    questionPlaceholder: 'What would you like guidance on?',
    drawCards: '🃏 Draw Your Cards',
    reversed: '(Reversed)',
    upright: '(Upright)',
    loadingTarot: 'The cards are revealing their wisdom...',
    tarotResult: '🃏 Your Tarot Reading',
    drawNewCards: '🔄 Draw New Cards',

    // Transits
    transitsTitle: '🪐 Planetary Transits',
    transitsDesc: 'Discover how current planetary movements affect your sign',
    scanningCosmos: 'Scanning the Cosmos...',
    getTransits: '🪐 Get Transits for {sign}',
    loadingTransits: 'Tracking planetary movements...',
    transitsResult: '🪐 Planetary Transits — {sign}',

    // Vedic
    vedicTitle: '🕉️ Vedic Astrology (Jyotish)',
    vedicDesc: 'Explore the ancient Indian science of celestial wisdom',
    consultingJyotish: 'Consulting Jyotish...',
    getVedicReading: '🕉️ Get Vedic Reading',
    loadingVedic: 'Consulting the ancient Vedic wisdom...',
    vedicResult: '🕉️ Vedic Astrology Reading for {name}',

    // Chinese Zodiac
    chineseTitle: '🐉 Chinese Zodiac',
    chineseDesc: 'Discover your Chinese zodiac animal and its meaning',
    birthYear: 'Birth Year *',
    yearPlaceholder: 'e.g. 1995',
    discovering: 'Discovering...',
    discoverChinese: '🐉 Discover My Chinese Zodiac',
    yearOfThe: 'Year of the {animal}',
    bornIn: 'Born in {year}',
    loadingChinese: 'Exploring the Chinese zodiac...',
    chineseResult: '🐉 Year of the {animal} — {year}',
    invalidYear: 'Please enter a valid birth year (1900-2030).',

    // Ask Astrologer
    askTitle: '✨ Ask the AI Astrologer',
    askDesc: 'Your personal cosmic advisor — powered by OpenRouter AI',
    askGreeting: '✨ Greetings, cosmic seeker! I am your AI astrologer. Ask me anything about zodiac signs, birth charts, planetary transits, love compatibility, numerology, tarot, or any celestial matter. What would you like to explore today?',
    askLoading: '✨ The stars are aligning an answer for you...',
    askPlaceholder: 'Ask me anything about astrology...',
    sugQ1: 'What does Mercury retrograde mean?',
    sugQ2: 'How do I find my rising sign?',
    sugQ3: 'What are the most compatible zodiac pairs?',
    sugQ4: 'Explain the 12 houses in astrology',
    sugQ5: 'What is a grand trine?',
    sugQ6: 'How does Saturn return affect me?',

    // Common
    apiKeyError: 'Please connect your OpenRouter API key first.',
    apiKeyChat: '🔑 Please connect your OpenRouter API key first using the setup above.',

    // Moon Phase
    moonPhaseTitle: '🌙 Moon Phase Calendar',
    moonPhaseDesc: 'Track lunar cycles, tithis, and auspicious times',
    newMoon: 'New Moon',
    waxingCrescent: 'Waxing Crescent',
    firstQuarter: 'First Quarter',
    waxingGibbous: 'Waxing Gibbous',
    fullMoon: 'Full Moon',
    waningGibbous: 'Waning Gibbous',
    lastQuarter: 'Last Quarter',
    waningCrescent: 'Waning Crescent',
    illuminated: 'Illuminated',
    moonActivitiesTitle: 'Auspicious Activities Today',
    newBeginnings: 'New Beginnings',
    meditation: 'Meditation',
    cleansing: 'Cleansing',
    fasting: 'Fasting',
    favorable: 'Favorable',
    ideal: 'Ideal',
    waitForWaxing: 'Wait for waxing moon',
    waitForWaning: 'Wait for waning moon',
    goodAnytime: 'Good anytime',
    ekadashiToday: 'Ekadashi Today!',
    nextEkadashi: 'Check next Ekadashi',
    getMoonReading: '🌙 Get Detailed Moon Reading',
    loadingMoonReading: 'Reading the lunar energies...',
    moonReadingResult: 'Moon Phase Reading',

    // Muhurat
    muhuratTitle: '📅 Muhurat Finder',
    muhuratDesc: 'Find auspicious dates for important life events',
    selectActivity: 'Select Activity',
    muhuratWedding: 'Wedding',
    muhuratBusiness: 'Business',
    muhuratTravel: 'Travel',
    muhuratHousewarming: 'Housewarming',
    muhuratVehicle: 'Vehicle Purchase',
    muhuratEducation: 'Education',
    muhuratNaming: 'Naming Ceremony',
    muhuratInvestment: 'Investment',
    muhuratMedical: 'Medical',
    muhuratSpiritual: 'Spiritual',
    selectDateRange: 'Select Date Range',
    fromDate: 'From Date',
    toDate: 'To Date',
    yourZodiacOptional: 'Your Zodiac Sign (optional)',
    selectZodiac: 'Select zodiac sign...',
    findingMuhurat: 'Finding Muhurat...',
    findAuspiciousDates: '📅 Find Auspicious Dates',
    loadingMuhurat: 'Consulting the Panchang...',
    muhuratResult: 'Auspicious Dates Found',
    selectMuhuratType: 'Please select an activity type.',

    // Nakshatra
    nakshatraTitle: '⭐ Nakshatra Finder',
    nakshatraDesc: 'Discover your birth star (Janma Nakshatra) and its influence',
    the27Nakshatras: 'The 27 Nakshatras',
    findYourNakshatra: 'Find Your Nakshatra',
    fillDateOfBirth: 'Please enter your date of birth.',
    calculatingNakshatra: 'Calculating...',
    findMyNakshatra: '⭐ Find My Nakshatra',
    loadingNakshatra: 'Locating your birth star...',
    nakshatraResult: 'Your Nakshatra Reading',

    // Remedies
    remediesTitle: '🙏 Vedic Remedies',
    remediesDesc: 'Discover planetary remedies, gemstones, mantras & rituals',
    remedyTypes: 'Remedy Categories',
    remedyGemstones: 'Gemstones',
    remedyMantras: 'Mantras',
    remedyFasting: 'Fasting',
    remedyCharity: 'Charity',
    remedyYantra: 'Yantra',
    remedyPuja: 'Puja',
    selectYourSign: 'Select Your Zodiac Sign',
    orSelectDosha: 'Or Select a Dosha',
    specificConcern: 'Specific Concern (optional)',
    describeConcern: 'Describe your concern or what remedy you need...',
    findingRemedies: 'Finding Remedies...',
    getRemedies: '🙏 Get Remedies',
    loadingRemedies: 'Consulting Vedic wisdom...',
    remediesResult: 'Your Vedic Remedies',
    selectSignOrDosha: 'Please select a zodiac sign, dosha, or describe your concern.',
    quickRemedyGuide: 'Quick Remedy Guide by Day',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sundayRemedy: 'Worship Sun, wear Ruby, donate wheat',
    mondayRemedy: 'Worship Moon/Shiva, wear Pearl, donate rice',
    tuesdayRemedy: 'Worship Hanuman, wear Red Coral, donate red lentils',
    wednesdayRemedy: 'Worship Vishnu, wear Emerald, donate green moong',
    thursdayRemedy: 'Worship Jupiter/Guru, wear Yellow Sapphire, donate yellow items',
    fridayRemedy: 'Worship Lakshmi, wear Diamond, donate white items',
    saturdayRemedy: 'Worship Saturn, wear Blue Sapphire, donate black sesame',

    // Profile
    profileTitle: '👤 My Profile',
    profileDesc: 'Manage your birth details and saved readings',
    myProfile: 'My Profile',
    savedReadings: 'Saved Readings',
    favorites: 'Favorites',
    setupProfile: 'Setup Your Profile',
    editProfile: 'Edit Profile',
    saveProfile: 'Save Profile',
    cancel: 'Cancel',
    clearProfile: 'Clear Profile',
    confirmClearProfile: 'Are you sure you want to clear your profile? This cannot be undone.',
    lifePathNumber: 'Life Path Number',
    chineseZodiac: 'Chinese Zodiac',
    unnamed: 'Unnamed',
    noSavedReadings: 'No saved readings yet. Get readings and save them here!',
    noFavorites: 'No favorites yet. Star your favorite readings!',
    delete: 'Delete',

    // Extended Compatibility
    gunaCompatibility: 'Ashtakoot Guna Milan',
    gunaScore: 'Guna Score',
    outOf36: 'out of 36',

    // Tarot Spreads
    tarotSpread: 'Select Spread',
    threeCardSpread: 'Three Card (Past/Present/Future)',
    celticCross: 'Celtic Cross (10 cards)',
    loveSpread: 'Love Spread (5 cards)',
    careerSpread: 'Career Spread (5 cards)',
    yesNoSpread: 'Yes/No (1 card)',

    // Theme
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',

    // Share
    shareReading: 'Share Reading',
    copyToClipboard: 'Copy to Clipboard',
    copied: 'Copied!',

    // Nav additions
    navMoonPhase: 'Moon',
    navMuhurat: 'Muhurat',
    navNakshatra: 'Nakshatra',
    navRemedies: 'Remedies',
    navProfile: 'Profile',

    // Feature cards for home
    featureMoonPhase: 'Moon Phase Calendar',
    featureMoonPhaseDesc: 'Track lunar cycles, tithis, and auspicious times',
    featureMuhurat: 'Muhurat Finder',
    featureMuhuratDesc: 'Find auspicious dates for weddings, business & more',
    featureNakshatra: 'Nakshatra Finder',
    featureNakshatraDesc: 'Discover your birth star and its cosmic influence',
    featureRemedies: 'Vedic Remedies',
    featureRemediesDesc: 'Gemstones, mantras, pujas & remedies for planetary afflictions',
    featurePalmReading: 'Palm Reading',
    featurePalmReadingDesc: 'Upload your palm photo for AI-powered Hast Rekha analysis',

    // Palm Reading
    navPalmReading: 'Palm',
    navTemples: 'Temples',
    palmReadingTitle: '🖐️ Palm Reading',
    palmReadingDesc: 'Upload a clear photo of your palm for AI-powered Hast Rekha (palmistry) analysis',
    palmTipsTitle: 'Tips for Best Results',
    palmTip1: 'Use good lighting - natural daylight works best',
    palmTip2: 'Keep your palm flat and fingers slightly spread',
    palmTip3: 'Capture the entire palm including all lines',
    palmTip4: 'Ensure the image is clear and not blurry',
    selectPalmHand: 'Which hand would you like analyzed?',
    leftHand: 'Left Hand',
    rightHand: 'Right Hand',
    leftHandDesc: 'Your potential & inherited traits',
    rightHandDesc: 'Your current path & achievements',
    yourName: 'Your Name',
    optional: 'optional',
    enterYourName: 'Enter your name',
    gender: 'Gender',
    selectGender: 'Select gender...',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    uploadPalmPhoto: 'Upload Your Palm Photo',
    takePhoto: 'Take Photo',
    uploadFromGallery: 'Upload from Gallery',
    uploadPalmImage: 'Please upload a palm image first.',
    analyzingPalm: 'Analyzing Palm...',
    getPalmReading: '🖐️ Get Palm Reading',
    loadingPalmReading: 'Analyzing the lines of your destiny...',
    palmReadingResult: 'Your Palm Reading',
    palmLinesGuide: 'Understanding Palm Lines',
    heartLine: 'Heart Line',
    heartLineDesc: 'Represents emotions, love, and relationships',
    headLine: 'Head Line',
    headLineDesc: 'Indicates intellect, thought patterns, and decision making',
    lifeLine: 'Life Line',
    lifeLineDesc: 'Shows vitality, life changes, and physical wellbeing',
    fateLine: 'Fate Line',
    fateLineDesc: 'Reveals career path, success, and life direction',

    // Kundali
    kundaliTitle: '🪬 Kundali / Birth Chart',
    kundaliDesc: 'Generate your complete Vedic birth chart with Lagna and Navamsa charts',
    navKundali: 'Kundali',
    generateKundali: '🪬 Generate Kundali',
    analyzingKundali: 'Analyzing Kundali...',
    getKundaliReading: '✨ Get AI Kundali Reading',
    loadingKundali: 'Analyzing your Vedic birth chart...',
    kundaliResult: '🪬 Kundali Reading for {name}',
    fillDateOfBirth: 'Please enter your date of birth.',
    native: 'Native',
    lagna: 'Lagna',
    lagnaChart: 'Lagna Chart (D1)',
    navamsaChart: 'Navamsa Chart (D9)',
    planetaryPositions: 'Planetary Positions',
    planet: 'Planet',
    sign: 'Sign',
    degree: 'Degree',
    house: 'House',
    nakshatra: 'Nakshatra',
    status: 'Status',
    dob: 'DOB',
    time: 'Time',
    aboutKundali: 'About Kundali (Birth Chart)',
    lagnaChartDesc: 'The Lagna Chart (Rashi Chart) shows planetary positions at birth. It reveals personality, life path, and overall destiny.',
    navamsaChartDesc: 'The Navamsa (D9) is the most important divisional chart. It indicates marriage, spouse, and spiritual growth.',
    nineGrahas: 'Nine Grahas (Planets)',
    nineGrahasDesc: 'Sun, Moon, Mars, Mercury, Jupiter, Venus, Saturn, Rahu, and Ketu influence different aspects of life.',
    twelveHouses: 'Twelve Bhavas (Houses)',
    twelveHousesDesc: 'Each house represents different life areas: self, wealth, siblings, home, children, health, marriage, transformation, fortune, career, gains, and liberation.',
    featureKundali: 'Kundali Generator',
    featureKundaliDesc: 'Generate your Lagna and Navamsa charts with detailed planetary analysis',

    // Janma Nakshatra & Rashi
    janmaNakshatra: 'Janma Nakshatra',
    janmaRashi: 'Janma Rashi',
    pada: 'Pada',
    padaNum: 'Pada {num}',
    rashiLord: 'Rashi Lord',
    nakshatraLord: 'Nakshatra Lord',
    namingSyllable: 'Naming Syllable',
    nakshatraDeity: 'Deity',
    moonDegree: 'Moon Position',
    asPerPanchang: 'As per Shatabdi Panchang',
    ayanamsa: 'Ayanamsa',
    timezone: 'Timezone',

    // Planet Names
    planetSun: 'Sun',
    planetMoon: 'Moon',
    planetMars: 'Mars',
    planetMercury: 'Mercury',
    planetJupiter: 'Jupiter',
    planetVenus: 'Venus',
    planetSaturn: 'Saturn',
    planetRahu: 'Rahu',
    planetKetu: 'Ketu',

    // Zodiac Sign Names
    signAries: 'Aries',
    signTaurus: 'Taurus',
    signGemini: 'Gemini',
    signCancer: 'Cancer',
    signLeo: 'Leo',
    signVirgo: 'Virgo',
    signLibra: 'Libra',
    signScorpio: 'Scorpio',
    signSagittarius: 'Sagittarius',
    signCapricorn: 'Capricorn',
    signAquarius: 'Aquarius',
    signPisces: 'Pisces',

    // Planetary Strength Analysis
    planetaryStrength: 'Planetary Strength Analysis',
    dignity: 'Dignity',
    strength: 'Strength',
    level: 'Level',
    strong: 'Strong',
    medium: 'Medium',
    weak: 'Weak',
    exalted: 'Exalted',
    debilitated: 'Debilitated',
    ownSign: 'Own Sign',
    combust: 'Combust',
    neutral: 'Neutral',

    // Manglik
    manglikDosha: 'Manglik Dosha',
    manglikYes: 'Yes',
    manglikNo: 'No Dosha',
    manglikCancelled: 'Cancelled by Jupiter',
    manglikHouse: 'House',
    manglikLow: 'Low',
    manglikMedium: 'Medium',
    manglikHigh: 'High',

    // Weekly Periods
    weeklyPlanetaryPeriods: 'Weekly Planetary Periods (Vara)',
    todaysRulingPlanet: "Today's Ruling Planet",
    currentHoraLord: 'Current Hora Lord',
    today: 'Today',

    // Day Names
    daySunday: 'Sunday',
    dayMonday: 'Monday',
    dayTuesday: 'Tuesday',
    dayWednesday: 'Wednesday',
    dayThursday: 'Thursday',
    dayFriday: 'Friday',
    daySaturday: 'Saturday',
    daySundayHi: 'Ravivaar',
    dayMondayHi: 'Somvaar',
    dayTuesdayHi: 'Mangalvaar',
    dayWednesdayHi: 'Budhvaar',
    dayThursdayHi: 'Guruvaar',
    dayFridayHi: 'Shukravaar',
    daySaturdayHi: 'Shanivaar',

    // House Analysis
    houseAnalysis: 'House Analysis & Remedies',
    significance: 'Significance',
    planets: 'Planets',
    houseStrong: 'Strong',
    houseModerate: 'Moderate',
    houseWeak: 'Weak',

    // House Significance
    house1Sig: 'Self, Personality, Health',
    house2Sig: 'Wealth, Family, Speech',
    house3Sig: 'Siblings, Courage, Communication',
    house4Sig: 'Mother, Home, Vehicles, Education',
    house5Sig: 'Children, Intelligence, Creativity',
    house6Sig: 'Enemies, Debts, Health Issues',
    house7Sig: 'Marriage, Partnership, Business',
    house8Sig: 'Longevity, Obstacles, Occult',
    house9Sig: 'Fortune, Father, Religion, Higher Learning',
    house10Sig: 'Career, Profession, Status',
    house11Sig: 'Gains, Income, Friendships',
    house12Sig: 'Losses, Expenses, Spirituality, Foreign Travel',

    // Remedies
    recommendedRemedies: 'Recommended Remedies for Weak Houses',
    gemstone: 'Gemstone',
    mantra: 'Mantra',
    wearColor: 'Wear Color',
    on: 'on',
    duration: 'Duration',
    followFor: 'Follow for',

    // Chart Style
    chartStyle: 'Chart Style',
    southIndian: 'South Indian',
    northIndian: 'North Indian',
    asc: 'Asc',

    // Save Options
    saveToProfile: 'Save to Profile',
    saveAsPDF: 'Save as PDF',
    savedToProfile: 'Kundali saved to your profile!',
    downloadingPDF: 'Preparing PDF...',
  },

  te: {
    // Navbar
    navHome: 'హోమ్',
    navHoroscope: 'రాశిఫలం',
    navBirthChart: 'జన్మ చార్ట్',
    navCompatibility: 'అనుకూలత',
    navNumerology: 'సంఖ్యాశాస్త్రం',
    navTarot: 'టారో',
    navVedic: 'వేదిక్',
    navAskAI: 'AI ని అడగండి',
    navMoonPhase: 'చంద్ర దశ',
    navNakshatra: 'నక్షత్రం',
    navMuhurat: 'ముహూర్తం',
    navRemedies: 'నివారణలు',
    navPalmReading: 'హస్త రేఖ',
    navTemples: 'దేవాలయాలు',
    navMore: 'మరిన్ని',

    // Footer
    footerBrand: '🕉️ AstroA2Z — AI-ఆధారిత జ్యోతిషశాస్త్రం 🪷',
    footerPowered: 'AI ద్వారా నడుస్తుంది • వేద జ్ఞానంలో పాతుకుపోయింది • మార్గదర్శకత్వం మరియు వినోదం కోసం',

    // Loading
    defaultLoading: 'నక్షత్రాలను సంప్రదిస్తోంది...',

    // Home
    heroTagline: 'మీ పూర్తి AI-ఆధారిత జ్యోతిషశాస్త్ర సహచరుడు. వ్యక్తిగతీకరించిన రాశిఫలాలు, జన్మ చార్ట్‌లు, అనుకూలత పఠనాలు మరియు మరిన్నింటితో మీ విశ్వ బ్లూప్రింట్‌ను కనుగొనండి.',
    heroBtn1: '🔮 మీ రాశిఫలం పొందండి',
    heroBtn2: '🪬 కుండలి',
    heroBtn3: '✨ AI జ్యోతిష్కుడిని అడగండి',
    exploreTitle: 'విశ్వాన్ని అన్వేషించండి',
    exploreDesc: 'మీ జ్యోతిషశాస్త్ర ప్రయాణానికి అవసరమైన ప్రతిదీ, OpenRouter AI ద్వారా',
    zodiacTitle: '12 రాశులు',
    zodiacDesc: 'మీ రాశిఫలం పొందడానికి మీ రాశిపై క్లిక్ చేయండి',
    featureDailyHoroscope: 'దినసరి రాశిఫలం',
    featureDailyHoroscopeDesc: 'AI ద్వారా మీ రోజువారీ, వారపు, నెలవారీ & వార్షిక రాశిఫలం పొందండి',
    featureBirthChart: 'జన్మ చార్ట్',
    featureBirthChartDesc: 'గ్రహ స్థానాలతో మీ పూర్తి జాతక చార్ట్‌ను తయారు చేయండి',
    featureCompatibility: 'అనుకూలత',
    featureCompatibilityDesc: 'ఏదైనా రెండు రాశుల మధ్య ప్రేమ అనుకూలతను తనిఖీ చేయండి',
    featureNumerology: 'సంఖ్యాశాస్త్రం',
    featureNumerologyDesc: 'మీ జీవన మార్గం సంఖ్య మరియు సంఖ్యాశాస్త్ర ప్రొఫైల్‌ను కనుగొనండి',
    featureTarotReading: 'టారో రీడింగ్',
    featureTarotReadingDesc: 'మార్గదర్శకత్వం కోసం AI-వ్యాఖ్యానించిన టారో కార్డ్ రీడింగ్‌లు పొందండి',
    featureVedicAstrology: 'వేద జ్యోతిషశాస్త్రం',
    featureVedicAstrologyDesc: 'జ్యోతిష్ — నక్షత్రం, దశ, దోషం & నివారణలను అన్వేషించండి',
    featurePlanetaryTransits: 'గ్రహ సంచారాలు',
    featurePlanetaryTransitsDesc: 'ప్రస్తుత గ్రహ కదలికలు మరియు మీ రాశిపై వాటి ప్రభావాలు',
    featureChineseZodiac: 'చైనీస్ రాశిచక్రం',
    featureChineseZodiacDesc: 'మీ చైనీస్ రాశిచక్రం జంతువు మరియు మూలకాన్ని కనుగొనండి',
    featureAskAstrologer: 'జ్యోతిష్కుడిని అడగండి',
    featureAskAstrologerDesc: 'ఏదైనా విశ్వ విషయం గురించి మా AI జ్యోతిష్కుడితో చాట్ చేయండి',

    // Horoscope
    horoscopeTitle: '🔮 రాశిఫలం',
    horoscopeDesc: 'మీ రాశిని ఎంచుకోండి మరియు మీ వ్యక్తిగత రాశిఫలం పొందండి',
    daily: 'రోజువారీ',
    weekly: 'వారపు',
    monthly: 'నెలవారీ',
    yearly: 'వార్షిక',
    readingStars: 'నక్షత్రాలను చదువుతోంది...',
    getHoroscope: '{sign} కోసం {period} రాశిఫలం పొందండి',
    loadingHoroscope: '{sign} కోసం {period} విశ్వ శక్తులను చదువుతోంది...',
    horoscopeResult: '🔮 {period} రాశిఫలం — {sign}',

    // Birth Chart
    birthChartTitle: '🪬 కుండలి / జాతక చార్ట్',
    birthChartDesc: 'మీ పూర్తి జాతక చార్ట్ రీడింగ్ కోసం మీ జన్మ వివరాలను నమోదు చేయండి',
    fullName: 'పూర్తి పేరు *',
    dateOfBirth: 'జన్మ తేదీ *',
    timeOfBirth: 'జన్మ సమయం',
    placeOfBirth: 'జన్మ స్థలం',
    enterFullName: 'మీ పూర్తి పేరు నమోదు చేయండి',
    cityCountry: 'నగరం, దేశం',
    generatingChart: 'చార్ట్ తయారు చేస్తోంది...',
    generateBirthChart: '🪬 కుండలి తయారు చేయండి',
    loadingBirthChart: 'మీ ఖగోళ బ్లూప్రింట్‌ను మ్యాపింగ్ చేస్తోంది...',
    elementSign: '{element} రాశి • {ruler} పాలిత',
    natalChartReading: '🪬 జాతక కుండలి రీడింగ్',
    fillNameDob: 'దయచేసి కనీసం మీ పేరు మరియు జన్మ తేదీని నమోదు చేయండి.',

    // Compatibility
    compatibilityTitle: '💕 అనుకూలత తనిఖీ',
    compatibilityDesc: 'రెండు రాశుల మధ్య విశ్వ రసాయనశాస్త్రాన్ని కనుగొనండి',
    person1Name: 'వ్యక్తి 1 పేరు (ఐచ్ఛికం)',
    person2Name: 'వ్యక్తి 2 పేరు (ఐచ్ఛికం)',
    firstPersonName: 'మొదటి వ్యక్తి పేరు',
    secondPersonName: 'రెండవ వ్యక్తి పేరు',
    selectSign1: 'రాశి 1 ఎంచుకోండి',
    selectSign2: 'రాశి 2 ఎంచుకోండి',
    selectingPerson1: '👆 వ్యక్తి 1 కోసం ఎంపిక చేస్తోంది',
    selectingPerson2: '👆 వ్యక్తి 2 కోసం ఎంపిక చేస్తోంది',
    checkingStars: 'నక్షత్రాలను తనిఖీ చేస్తోంది...',
    checkCompatibility: '💕 {sign1} & {sign2} అనుకూలత తనిఖీ చేయండి',
    loadingCompatibility: 'విశ్వ సంబంధాన్ని విశ్లేషిస్తోంది...',
    compatibilityResult: '💕 {sign1} & {sign2} అనుకూలత',
    selectBothSigns: 'దయచేసి రెండు రాశులను ఎంచుకోండి.',

    // Numerology
    numerologyTitle: '🔢 సంఖ్యాశాస్త్రం',
    numerologyDesc: 'మీ జీవితంలో సంఖ్యల దాగిన అర్థాన్ని కనుగొనండి',
    calculating: 'లెక్కిస్తోంది...',
    calculateNumerology: '🔢 సంఖ్యాశాస్త్రం లెక్కించండి',
    loadingNumerology: 'మీ విధి సంఖ్యలను డీకోడ్ చేస్తోంది...',
    lifePathNumber: 'మీ జీవన మార్గం సంఖ్య',
    masterNumber: '✨ మాస్టర్ నంబర్ — మీరు అసాధారణ సామర్థ్యం కలిగి ఉన్నారు!',
    uniqueFrequency: '✨ మీ ప్రత్యేక కంపన ఫ్రీక్వెన్సీ',
    numerologyResult: '🔢 {name} కోసం సంఖ్యాశాస్త్ర రీడింగ్',
    enterNameDob: 'దయచేసి మీ పేరు మరియు జన్మ తేదీని నమోదు చేయండి.',

    // Tarot
    tarotTitle: '🃏 టారో రీడింగ్',
    tarotDesc: 'గతం, వర్తమానం మరియు భవిష్యత్తు మార్గదర్శకత్వం కోసం మూడు కార్డ్‌లు డ్రా చేయండి',
    tarotIntro: 'మీ ప్రశ్న లేదా ఉద్దేశ్యంపై దృష్టి పెట్టండి, తర్వాత మీ కార్డ్‌లను డ్రా చేయండి. సాధారణ జీవిత రీడింగ్ కోసం ప్రశ్నను ఖాళీగా వదిలేయండి.',
    yourQuestion: 'మీ ప్రశ్న (ఐచ్ఛికం)',
    questionPlaceholder: 'మీకు ఏ విషయంలో మార్గదర్శకత్వం కావాలి?',
    drawCards: '🃏 మీ కార్డ్‌లను డ్రా చేయండి',
    reversed: '(తిరగబడిన)',
    upright: '(నిటారు)',
    loadingTarot: 'కార్డ్‌లు తమ జ్ఞానాన్ని వెల్లడిస్తున్నాయి...',
    tarotResult: '🃏 మీ టారో రీడింగ్',
    drawNewCards: '🔄 కొత్త కార్డ్‌లు డ్రా చేయండి',

    // Transits
    transitsTitle: '🪐 గ్రహ సంచారాలు',
    transitsDesc: 'ప్రస్తుత గ్రహ కదలికలు మీ రాశిని ఎలా ప్రభావితం చేస్తాయో కనుగొనండి',
    scanningCosmos: 'విశ్వాన్ని స్కాన్ చేస్తోంది...',
    getTransits: '🪐 {sign} కోసం సంచారాలు పొందండి',
    loadingTransits: 'గ్రహ కదలికలను ట్రాక్ చేస్తోంది...',
    transitsResult: '🪐 గ్రహ సంచారాలు — {sign}',

    // Vedic
    vedicTitle: '🕉️ వేద జ్యోతిషశాస్త్రం (జ్యోతిష్)',
    vedicDesc: 'ఖగోళ జ్ఞానం యొక్క ప్రాచీన భారతీయ శాస్త్రాన్ని అన్వేషించండి',
    consultingJyotish: 'జ్యోతిష్‌ను సంప్రదిస్తోంది...',
    getVedicReading: '🕉️ వేద రీడింగ్ పొందండి',
    loadingVedic: 'ప్రాచీన వేద జ్ఞానాన్ని సంప్రదిస్తోంది...',
    vedicResult: '🕉️ {name} కోసం వేద జ్యోతిషశాస్త్ర రీడింగ్',

    // Chinese Zodiac
    chineseTitle: '🐉 చైనీస్ రాశిచక్రం',
    chineseDesc: 'మీ చైనీస్ రాశిచక్రం జంతువు మరియు దాని అర్థాన్ని కనుగొనండి',
    birthYear: 'జన్మ సంవత్సరం *',
    yearPlaceholder: 'ఉదా. 1995',
    discovering: 'కనుగొంటోంది...',
    discoverChinese: '🐉 నా చైనీస్ రాశిచక్రం కనుగొనండి',
    yearOfThe: '{animal} సంవత్సరం',
    bornIn: '{year} లో జన్మించారు',
    loadingChinese: 'చైనీస్ రాశిచక్రాన్ని అన్వేషిస్తోంది...',
    chineseResult: '🐉 {animal} సంవత్సరం — {year}',
    invalidYear: 'దయచేసి చెల్లుబాటు అయ్యే జన్మ సంవత్సరం (1900-2030) నమోదు చేయండి.',

    // Ask Astrologer
    askTitle: '✨ AI జ్యోతిష్కుడిని అడగండి',
    askDesc: 'మీ వ్యక్తిగత విశ్వ సలహాదారు — OpenRouter AI ద్వారా',
    askGreeting: '✨ నమస్కారం, విశ్వ అన్వేషకా! నేను మీ AI జ్యోతిష్కుడిని. రాశులు, జన్మ చార్ట్‌లు, గ్రహ సంచారాలు, ప్రేమ అనుకూలత, సంఖ్యాశాస్త్రం, టారో లేదా ఏదైనా ఖగోళ విషయం గురించి నన్ను అడగండి. మీరు ఈ రోజు ఏమి అన్వేషించాలనుకుంటున్నారు?',
    askLoading: '✨ నక్షత్రాలు మీ కోసం సమాధానాన్ని అమర్చుతున్నాయి...',
    askPlaceholder: 'జ్యోతిషశాస్త్రం గురించి ఏదైనా అడగండి...',
    sugQ1: 'బుధ వక్రం అంటే ఏమిటి?',
    sugQ2: 'నా ఉదయ రాశిని ఎలా కనుగొనాలి?',
    sugQ3: 'అత్యంత అనుకూలమైన రాశి జంటలు ఏమిటి?',
    sugQ4: 'జ్యోతిషశాస్త్రంలో 12 భావాలను వివరించండి',
    sugQ5: 'గ్రాండ్ ట్రైన్ అంటే ఏమిటి?',
    sugQ6: 'శని రిటర్న్ నన్ను ఎలా ప్రభావితం చేస్తుంది?',

    // Common
    apiKeyError: 'దయచేసి ముందుగా మీ OpenRouter API కీని కనెక్ట్ చేయండి.',
    apiKeyChat: '🔑 దయచేసి ముందుగా పై సెటప్ ఉపయోగించి మీ OpenRouter API కీని కనెక్ట్ చేయండి.',

    // Kundali
    kundaliTitle: '🪬 కుండలి / జాతక చార్ట్',
    kundaliDesc: 'లగ్న మరియు నవాంశ చార్ట్‌లతో మీ పూర్తి వేద జాతక చార్ట్‌ను తయారు చేయండి',
    navKundali: 'కుండలి',
    generateKundali: '🪬 కుండలి తయారు చేయండి',
    analyzingKundali: 'కుండలిని విశ్లేషిస్తోంది...',
    getKundaliReading: '✨ AI కుండలి రీడింగ్ పొందండి',
    loadingKundali: 'మీ వేద జాతక చార్ట్‌ను విశ్లేషిస్తోంది...',
    kundaliResult: '🪬 {name} కోసం కుండలి రీడింగ్',
    fillDateOfBirth: 'దయచేసి మీ జన్మ తేదీని నమోదు చేయండి.',
    native: 'జాతకుడు',
    lagna: 'లగ్నం',
    lagnaChart: 'లగ్న చార్ట్ (D1)',
    navamsaChart: 'నవాంశ చార్ట్ (D9)',
    planetaryPositions: 'గ్రహ స్థానాలు',
    planet: 'గ్రహం',
    sign: 'రాశి',
    degree: 'డిగ్రీ',
    house: 'భావం',
    nakshatra: 'నక్షత్రం',
    status: 'స్థితి',
    dob: 'జన్మ తేదీ',
    time: 'సమయం',
    aboutKundali: 'కుండలి (జాతక చార్ట్) గురించి',
    lagnaChartDesc: 'లగ్న చార్ట్ (రాశి చార్ట్) జన్మ సమయంలో గ్రహ స్థానాలను చూపిస్తుంది. ఇది వ్యక్తిత్వం, జీవన మార్గం మరియు మొత్తం విధిని వెల్లడిస్తుంది.',
    navamsaChartDesc: 'నవాంశ (D9) అత్యంత ముఖ్యమైన విభాగ చార్ట్. ఇది వివాహం, జీవిత భాగస్వామి మరియు ఆధ్యాత్మిక వృద్ధిని సూచిస్తుంది.',
    nineGrahas: 'నవ గ్రహాలు',
    nineGrahasDesc: 'సూర్యుడు, చంద్రుడు, కుజుడు, బుధుడు, గురువు, శుక్రుడు, శని, రాహువు మరియు కేతువు జీవితంలో వివిధ అంశాలను ప్రభావితం చేస్తాయి.',
    twelveHouses: 'పన్నెండు భావాలు',
    twelveHousesDesc: 'ప్రతి భావం వివిధ జీవిత రంగాలను సూచిస్తుంది: తనువు, ధనం, సోదరులు, గృహం, సంతానం, ఆరోగ్యం, వివాహం, పరివర్తన, భాగ్యం, వృత్తి, లాభాలు మరియు మోక్షం.',
    featureKundali: 'కుండలి జనరేటర్',
    featureKundaliDesc: 'వివరమైన గ్రహ విశ్లేషణతో మీ లగ్న మరియు నవాంశ చార్ట్‌లను తయారు చేయండి',

    // Janma Nakshatra & Rashi
    janmaNakshatra: 'జన్మ నక్షత్రం',
    janmaRashi: 'జన్మ రాశి',
    pada: 'పాదం',
    padaNum: 'పాదం {num}',
    rashiLord: 'రాశి అధిపతి',
    nakshatraLord: 'నక్షత్ర అధిపతి',
    namingSyllable: 'నామాక్షరం',
    nakshatraDeity: 'అధిదేవత',
    moonDegree: 'చంద్ర స్థానం',
    asPerPanchang: 'శతాబ్ది పంచాంగం ప్రకారం',
    ayanamsa: 'అయనాంశ',
    timezone: 'సమయ మండలం',

    // Planet Names (Telugu)
    planetSun: 'సూర్యుడు',
    planetMoon: 'చంద్రుడు',
    planetMars: 'కుజుడు',
    planetMercury: 'బుధుడు',
    planetJupiter: 'గురువు',
    planetVenus: 'శుక్రుడు',
    planetSaturn: 'శని',
    planetRahu: 'రాహువు',
    planetKetu: 'కేతువు',

    // Zodiac Sign Names (Telugu)
    signAries: 'మేషం',
    signTaurus: 'వృషభం',
    signGemini: 'మిథునం',
    signCancer: 'కర్కాటకం',
    signLeo: 'సింహం',
    signVirgo: 'కన్య',
    signLibra: 'తుల',
    signScorpio: 'వృశ్చికం',
    signSagittarius: 'ధనుస్సు',
    signCapricorn: 'మకరం',
    signAquarius: 'కుంభం',
    signPisces: 'మీనం',

    // Planetary Strength Analysis
    planetaryStrength: 'గ్రహ బలం విశ్లేషణ',
    dignity: 'స్థితి',
    strength: 'బలం',
    level: 'స్థాయి',
    strong: 'బలవంతుడు',
    medium: 'మధ్యస్థం',
    weak: 'బలహీనం',
    exalted: 'ఉచ్చ',
    debilitated: 'నీచ',
    ownSign: 'స్వగృహం',
    combust: 'అస్తంగత',
    neutral: 'సమం',

    // Manglik
    manglikDosha: 'మంగళ దోషం',
    manglikYes: 'ఉంది',
    manglikNo: 'దోషం లేదు',
    manglikCancelled: 'గురువు వల్ల రద్దు',
    manglikHouse: 'భావం',
    manglikLow: 'తక్కువ',
    manglikMedium: 'మధ్యస్థం',
    manglikHigh: 'ఎక్కువ',

    // Weekly Periods
    weeklyPlanetaryPeriods: 'వారపు గ్రహ కాలాలు (వార)',
    todaysRulingPlanet: 'నేటి పాలక గ్రహం',
    currentHoraLord: 'ప్రస్తుత హోరా అధిపతి',
    today: 'ఈరోజు',

    // Day Names (Telugu)
    daySunday: 'ఆదివారం',
    dayMonday: 'సోమవారం',
    dayTuesday: 'మంగళవారం',
    dayWednesday: 'బుధవారం',
    dayThursday: 'గురువారం',
    dayFriday: 'శుక్రవారం',
    daySaturday: 'శనివారం',
    daySundayHi: 'రవివారం',
    dayMondayHi: 'సోమవారం',
    dayTuesdayHi: 'మంగళవారం',
    dayWednesdayHi: 'బుధవారం',
    dayThursdayHi: 'గురువారం',
    dayFridayHi: 'శుక్రవారం',
    daySaturdayHi: 'శనివారం',

    // House Analysis
    houseAnalysis: 'భావ విశ్లేషణ & నివారణలు',
    significance: 'ప్రాముఖ్యత',
    planets: 'గ్రహాలు',
    houseStrong: 'బలవంతం',
    houseModerate: 'మధ్యస్థం',
    houseWeak: 'బలహీనం',

    // House Significance (Telugu)
    house1Sig: 'తనువు, వ్యక్తిత్వం, ఆరోగ్యం',
    house2Sig: 'ధనం, కుటుంబం, వాక్కు',
    house3Sig: 'సోదరులు, ధైర్యం, సంభాషణ',
    house4Sig: 'తల్లి, గృహం, వాహనాలు, విద్య',
    house5Sig: 'సంతానం, బుద్ధి, సృజనాత్మకత',
    house6Sig: 'శత్రువులు, అప్పులు, ఆరోగ్య సమస్యలు',
    house7Sig: 'వివాహం, భాగస్వామ్యం, వ్యాపారం',
    house8Sig: 'ఆయుష్షు, అడ్డంకులు, రహస్య జ్ఞానం',
    house9Sig: 'భాగ్యం, తండ్రి, ధర్మం, ఉన్నత విద్య',
    house10Sig: 'వృత్తి, వ్యవసాయం, హోదా',
    house11Sig: 'లాభాలు, ఆదాయం, స్నేహాలు',
    house12Sig: 'నష్టాలు, వ్యయం, ఆధ్యాత్మికత, విదేశ ప్రయాణం',

    // Remedies
    recommendedRemedies: 'బలహీన భావాలకు సిఫార్సు చేసిన నివారణలు',
    gemstone: 'రత్నం',
    mantra: 'మంత్రం',
    wearColor: 'ధరించే రంగు',
    on: 'న',
    duration: 'కాలం',
    followFor: 'అనుసరించండి',

    // Chart Style
    chartStyle: 'చార్ట్ శైలి',
    southIndian: 'దక్షిణ భారతీయ',
    northIndian: 'ఉత్తర భారతీయ',
    asc: 'లగ్నం',

    // Save Options
    saveToProfile: 'ప్రొఫైల్‌లో సేవ్ చేయండి',
    saveAsPDF: 'PDF గా సేవ్ చేయండి',
    savedToProfile: 'కుండలి మీ ప్రొఫైల్‌లో సేవ్ చేయబడింది!',
    downloadingPDF: 'PDF తయారు చేస్తోంది...',
  },

  hi: {
    // Navbar
    navHome: 'होम',
    navHoroscope: 'राशिफल',
    navBirthChart: 'जन्म कुंडली',
    navCompatibility: 'अनुकूलता',
    navNumerology: 'अंक ज्योतिष',
    navTarot: 'टैरो',
    navVedic: 'वैदिक',
    navAskAI: 'AI से पूछें',
    navMoonPhase: 'चंद्र कला',
    navNakshatra: 'नक्षत्र',
    navMuhurat: 'मुहूर्त',
    navRemedies: 'उपाय',
    navPalmReading: 'हस्तरेखा',
    navTemples: 'मंदिर',
    navMore: 'और',
    navKundali: 'कुंडली',
    navProfile: 'प्रोफ़ाइल',

    // Footer
    footerBrand: '🕉️ AstroA2Z — AI-संचालित ज्योतिष 🪷',
    footerPowered: 'AI द्वारा संचालित • वैदिक ज्ञान में निहित • मार्गदर्शन और मनोरंजन के लिए',

    // Loading
    defaultLoading: 'सितारों से सलाह ली जा रही है...',

    // Home
    heroTagline: 'आपका संपूर्ण AI-संचालित ज्योतिष साथी। व्यक्तिगत राशिफल, कुंडली, अनुकूलता पठन और वैदिक ज्ञान के साथ अपना ब्रह्मांडीय खाका खोजें।',
    heroBtn1: '🪷 अपना राशिफल पाएं',
    heroBtn2: '🪬 कुंडली',
    heroBtn3: '✨ AI ज्योतिषी से पूछें',
    exploreTitle: 'ब्रह्मांडीय ज्ञान का अन्वेषण करें',
    exploreDesc: 'आपकी ज्योतिष यात्रा के लिए आवश्यक सब कुछ, AI और वैदिक ज्ञान द्वारा संचालित',
    zodiacTitle: '12 राशियाँ',
    zodiacDesc: 'अपना व्यक्तिगत राशिफल पाने के लिए अपनी राशि पर क्लिक करें',
    featureDailyHoroscope: 'दैनिक राशिफल',
    featureDailyHoroscopeDesc: 'AI द्वारा संचालित दैनिक, साप्ताहिक, मासिक और वार्षिक राशिफल पाएं',
    featureBirthChart: 'जन्म कुंडली',
    featureBirthChartDesc: 'ग्रह स्थितियों के साथ अपनी पूर्ण जन्म कुंडली बनाएं',
    featureCompatibility: 'अनुकूलता',
    featureCompatibilityDesc: 'किन्हीं दो राशियों के बीच प्रेम अनुकूलता की जाँच करें',
    featureNumerology: 'अंक ज्योतिष',
    featureNumerologyDesc: 'अपना लाइफ पाथ नंबर और अंक ज्योतिषीय प्रोफ़ाइल खोजें',
    featureTarotReading: 'टैरो रीडिंग',
    featureTarotReadingDesc: 'मार्गदर्शन के लिए AI-व्याख्यायित टैरो कार्ड रीडिंग पाएं',
    featureVedicAstrology: 'वैदिक ज्योतिष',
    featureVedicAstrologyDesc: 'प्राचीन ज्योतिष — नक्षत्र, दशा, ग्रह दोष और वैदिक उपायों का अन्वेषण करें',
    featurePlanetaryTransits: 'ग्रह गोचर',
    featurePlanetaryTransitsDesc: 'वर्तमान ग्रह गति और आपकी राशि पर उनका प्रभाव',
    featureChineseZodiac: 'चीनी राशिचक्र',
    featureChineseZodiacDesc: 'अपना चीनी राशि पशु और तत्व खोजें',
    featureAskAstrologer: 'ज्योतिषी से पूछें',
    featureAskAstrologerDesc: 'किसी भी ब्रह्मांडीय विषय पर हमारे AI ज्योतिषी से बात करें',

    // Horoscope
    horoscopeTitle: '🔮 राशिफल',
    horoscopeDesc: 'अपनी राशि चुनें और अपना व्यक्तिगत राशिफल पाएं',
    daily: 'दैनिक',
    weekly: 'साप्ताहिक',
    monthly: 'मासिक',
    yearly: 'वार्षिक',
    readingStars: 'सितारे पढ़े जा रहे हैं...',
    getHoroscope: '{sign} के लिए {period} राशिफल पाएं',
    loadingHoroscope: '{sign} के लिए {period} ब्रह्मांडीय ऊर्जा पढ़ी जा रही है...',
    horoscopeResult: '🔮 {period} राशिफल — {sign}',

    // Birth Chart
    birthChartTitle: '🪬 कुंडली / जन्म कुंडली',
    birthChartDesc: 'अपनी पूर्ण कुंडली रीडिंग के लिए अपने जन्म विवरण दर्ज करें',
    fullName: 'पूरा नाम *',
    dateOfBirth: 'जन्म तिथि *',
    timeOfBirth: 'जन्म समय',
    placeOfBirth: 'जन्म स्थान',
    enterFullName: 'अपना पूरा नाम दर्ज करें',
    cityCountry: 'शहर, देश',
    generatingChart: 'कुंडली बन रही है...',
    generateBirthChart: '🪬 कुंडली बनाएं',
    loadingBirthChart: 'आपका दिव्य नक्शा बनाया जा रहा है...',
    elementSign: '{element} राशि • {ruler} द्वारा शासित',
    natalChartReading: '🪬 जन्म कुंडली रीडिंग',
    fillNameDob: 'कृपया कम से कम अपना नाम और जन्म तिथि दर्ज करें।',

    // Compatibility
    compatibilityTitle: '💕 अनुकूलता जाँच',
    compatibilityDesc: 'दो राशियों के बीच ब्रह्मांडीय रसायन की खोज करें',
    person1Name: 'व्यक्ति 1 का नाम (वैकल्पिक)',
    person2Name: 'व्यक्ति 2 का नाम (वैकल्पिक)',
    firstPersonName: 'पहले व्यक्ति का नाम',
    secondPersonName: 'दूसरे व्यक्ति का नाम',
    selectSign1: 'राशि 1 चुनें',
    selectSign2: 'राशि 2 चुनें',
    selectingPerson1: '👆 व्यक्ति 1 के लिए चयन',
    selectingPerson2: '👆 व्यक्ति 2 के लिए चयन',
    checkingStars: 'सितारे जाँचे जा रहे हैं...',
    checkCompatibility: '💕 {sign1} और {sign2} की अनुकूलता जाँचें',
    loadingCompatibility: 'ब्रह्मांडीय संबंध का विश्लेषण किया जा रहा है...',
    compatibilityResult: '💕 {sign1} और {sign2} की अनुकूलता',
    selectBothSigns: 'कृपया दोनों राशियाँ चुनें।',

    // Numerology
    numerologyTitle: '🔢 अंक ज्योतिष',
    numerologyDesc: 'अपने जीवन में संख्याओं का छिपा अर्थ खोजें',
    calculating: 'गणना हो रही है...',
    calculateNumerology: '🔢 अंक ज्योतिष की गणना करें',
    loadingNumerology: 'आपकी नियति की संख्याओं को डिकोड किया जा रहा है...',
    lifePathNumber: 'आपका लाइफ पाथ नंबर',
    masterNumber: '✨ मास्टर नंबर — आपके पास असाधारण क्षमता है!',
    uniqueFrequency: '✨ आपकी अनूठी कंपन आवृत्ति',
    numerologyResult: '🔢 {name} के लिए अंक ज्योतिष रीडिंग',
    enterNameDob: 'कृपया अपना नाम और जन्म तिथि दर्ज करें।',

    // Tarot
    tarotTitle: '🃏 टैरो रीडिंग',
    tarotDesc: 'अतीत, वर्तमान और भविष्य के मार्गदर्शन के लिए तीन कार्ड निकालें',
    tarotIntro: 'अपने प्रश्न या इरादे पर ध्यान केंद्रित करें, फिर अपने कार्ड निकालें। सामान्य जीवन रीडिंग के लिए प्रश्न खाली छोड़ें।',
    yourQuestion: 'आपका प्रश्न (वैकल्पिक)',
    questionPlaceholder: 'आप किस पर मार्गदर्शन चाहेंगे?',
    drawCards: '🃏 अपने कार्ड निकालें',
    reversed: '(उल्टा)',
    upright: '(सीधा)',
    loadingTarot: 'कार्ड अपना ज्ञान प्रकट कर रहे हैं...',
    tarotResult: '🃏 आपकी टैरो रीडिंग',
    drawNewCards: '🔄 नए कार्ड निकालें',

    // Transits
    transitsTitle: '🪐 ग्रह गोचर',
    transitsDesc: 'खोजें कि वर्तमान ग्रह गति आपकी राशि को कैसे प्रभावित करती है',
    scanningCosmos: 'ब्रह्मांड स्कैन हो रहा है...',
    getTransits: '🪐 {sign} के लिए गोचर पाएं',
    loadingTransits: 'ग्रह गति ट्रैक की जा रही है...',
    transitsResult: '🪐 ग्रह गोचर — {sign}',

    // Vedic
    vedicTitle: '🕉️ वैदिक ज्योतिष',
    vedicDesc: 'खगोलीय ज्ञान के प्राचीन भारतीय विज्ञान का अन्वेषण करें',
    consultingJyotish: 'ज्योतिष से सलाह ली जा रही है...',
    getVedicReading: '🕉️ वैदिक रीडिंग पाएं',
    loadingVedic: 'प्राचीन वैदिक ज्ञान से सलाह ली जा रही है...',
    vedicResult: '🕉️ {name} के लिए वैदिक ज्योतिष रीडिंग',

    // Chinese Zodiac
    chineseTitle: '🐉 चीनी राशिचक्र',
    chineseDesc: 'अपना चीनी राशि पशु और उसका अर्थ खोजें',
    birthYear: 'जन्म वर्ष *',
    yearPlaceholder: 'जैसे 1995',
    discovering: 'खोज की जा रही है...',
    discoverChinese: '🐉 मेरा चीनी राशिचक्र खोजें',
    yearOfThe: '{animal} का वर्ष',
    bornIn: '{year} में जन्म',
    loadingChinese: 'चीनी राशिचक्र का अन्वेषण किया जा रहा है...',
    chineseResult: '🐉 {animal} का वर्ष — {year}',
    invalidYear: 'कृपया एक मान्य जन्म वर्ष (1900-2030) दर्ज करें।',

    // Ask Astrologer
    askTitle: '✨ AI ज्योतिषी से पूछें',
    askDesc: 'आपका व्यक्तिगत ब्रह्मांडीय सलाहकार — AI द्वारा संचालित',
    askGreeting: '✨ नमस्कार, ब्रह्मांडीय खोजी! मैं आपका AI ज्योतिषी हूँ। राशियों, कुंडली, ग्रह गोचर, प्रेम अनुकूलता, अंक ज्योतिष, टैरो या किसी भी खगोलीय विषय के बारे में मुझसे पूछें। आज आप क्या खोजना चाहेंगे?',
    askLoading: '✨ सितारे आपके लिए उत्तर तैयार कर रहे हैं...',
    askPlaceholder: 'ज्योतिष के बारे में कुछ भी पूछें...',
    sugQ1: 'बुध वक्री का क्या अर्थ है?',
    sugQ2: 'मैं अपनी लग्न राशि कैसे ढूंढूं?',
    sugQ3: 'सबसे अनुकूल राशि जोड़े कौन से हैं?',
    sugQ4: 'ज्योतिष में 12 भाव समझाएं',
    sugQ5: 'ग्रैंड ट्राइन क्या है?',
    sugQ6: 'शनि साढ़े साती मुझे कैसे प्रभावित करती है?',

    // Common
    apiKeyError: 'कृपया पहले अपनी OpenRouter API कुंजी कनेक्ट करें।',
    apiKeyChat: '🔑 कृपया पहले ऊपर दिए गए सेटअप का उपयोग करके अपनी OpenRouter API कुंजी कनेक्ट करें।',
  },

  ta: {
    // Navbar
    navHome: 'முகப்பு',
    navHoroscope: 'ராசிபலன்',
    navBirthChart: 'ஜாதகம்',
    navCompatibility: 'பொருத்தம்',
    navNumerology: 'எண் கணிதம்',
    navTarot: 'டாரோ',
    navVedic: 'வேத',
    navAskAI: 'AI யிடம் கேள்',
    navMoonPhase: 'சந்திர நிலை',
    navNakshatra: 'நட்சத்திரம்',
    navMuhurat: 'முகூர்த்தம்',
    navRemedies: 'பரிகாரம்',
    navPalmReading: 'கைரேகை',
    navTemples: 'கோவில்கள்',
    navMore: 'மேலும்',
    navKundali: 'குண்டலி',
    navProfile: 'சுயவிவரம்',

    // Footer
    footerBrand: '🕉️ AstroA2Z — AI-இயங்கும் ஜோதிடம் 🪷',
    footerPowered: 'AI மூலம் இயக்கப்படுகிறது • வேத ஞானத்தில் வேரூன்றியது • வழிகாட்டுதல் மற்றும் பொழுதுபோக்கிற்காக',

    // Loading
    defaultLoading: 'நட்சத்திரங்களை ஆலோசிக்கிறது...',

    // Home
    heroTagline: 'உங்கள் முழுமையான AI-இயங்கும் ஜோதிட துணை. தனிப்பயனாக்கப்பட்ட ராசிபலன்கள், ஜாதகம், பொருத்தம் வாசிப்புகள் மற்றும் வேத ஞானத்துடன் உங்கள் பிரபஞ்ச திட்டத்தைக் கண்டறியுங்கள்.',
    heroBtn1: '🪷 உங்கள் ராசிபலனைப் பெறுங்கள்',
    heroBtn2: '🪬 ஜாதகம்',
    heroBtn3: '✨ AI ஜோதிடரிடம் கேள்',
    exploreTitle: 'பிரபஞ்ச ஞானத்தை ஆராயுங்கள்',
    exploreDesc: 'உங்கள் ஜோதிட பயணத்திற்குத் தேவையான அனைத்தும், AI மற்றும் வேத அறிவால் இயக்கப்படுகிறது',
    zodiacTitle: '12 ராசிகள்',
    zodiacDesc: 'உங்கள் தனிப்பயன் ராசிபலனைப் பெற உங்கள் ராசியை கிளிக் செய்யுங்கள்',
    featureDailyHoroscope: 'தினசரி ராசிபலன்',
    featureDailyHoroscopeDesc: 'AI மூலம் உங்கள் தினசரி, வாராந்திர, மாதாந்திர மற்றும் வருடாந்திர ராசிபலனைப் பெறுங்கள்',
    featureBirthChart: 'ஜாதகம்',
    featureBirthChartDesc: 'கிரக நிலைகளுடன் உங்கள் முழுமையான ஜாதகத்தை உருவாக்குங்கள்',
    featureCompatibility: 'பொருத்தம்',
    featureCompatibilityDesc: 'எந்த இரண்டு ராசிகளுக்கும் இடையேயான காதல் பொருத்தத்தை சரிபார்க்கவும்',
    featureNumerology: 'எண் கணிதம்',
    featureNumerologyDesc: 'உங்கள் வாழ்க்கைப் பாதை எண் மற்றும் எண்ணியல் சுயவிவரத்தைக் கண்டறியுங்கள்',
    featureTarotReading: 'டாரோ வாசிப்பு',
    featureTarotReadingDesc: 'வழிகாட்டுதலுக்காக AI-விளக்கிய டாரோ அட்டை வாசிப்புகளைப் பெறுங்கள்',
    featureVedicAstrology: 'வேத ஜோதிடம்',
    featureVedicAstrologyDesc: 'பண்டைய ஜோதிடம் — நட்சத்திரம், தசை, கிரக தோஷம் & வேத பரிகாரங்களை ஆராயுங்கள்',
    featurePlanetaryTransits: 'கிரக சஞ்சாரம்',
    featurePlanetaryTransitsDesc: 'தற்போதைய கிரக இயக்கங்கள் மற்றும் உங்கள் ராசியில் அவற்றின் விளைவுகள்',
    featureChineseZodiac: 'சீன ராசி',
    featureChineseZodiacDesc: 'உங்கள் சீன ராசி விலங்கு மற்றும் தனிமத்தைக் கண்டறியுங்கள்',
    featureAskAstrologer: 'ஜோதிடரிடம் கேள்',
    featureAskAstrologerDesc: 'எந்த பிரபஞ்ச விஷயத்தைப் பற்றியும் எங்கள் AI ஜோதிடருடன் அரட்டையடிக்கவும்',

    // Horoscope
    horoscopeTitle: '🔮 ராசிபலன்',
    horoscopeDesc: 'உங்கள் ராசியைத் தேர்ந்தெடுத்து உங்கள் தனிப்பயன் ராசிபலனைப் பெறுங்கள்',
    daily: 'தினசரி',
    weekly: 'வாராந்திர',
    monthly: 'மாதாந்திர',
    yearly: 'வருடாந்திர',
    readingStars: 'நட்சத்திரங்களைப் படிக்கிறது...',
    getHoroscope: '{sign} க்கான {period} ராசிபலனைப் பெறுங்கள்',
    loadingHoroscope: '{sign} க்கான {period} பிரபஞ்ச சக்திகளைப் படிக்கிறது...',
    horoscopeResult: '🔮 {period} ராசிபலன் — {sign}',

    // Birth Chart
    birthChartTitle: '🪬 ஜாதகம் / ஜனன அட்டவணை',
    birthChartDesc: 'உங்கள் முழுமையான ஜாதக வாசிப்பிற்கு உங்கள் ஜனன விவரங்களை உள்ளிடவும்',
    fullName: 'முழுப் பெயர் *',
    dateOfBirth: 'பிறந்த தேதி *',
    timeOfBirth: 'பிறந்த நேரம்',
    placeOfBirth: 'பிறந்த இடம்',
    enterFullName: 'உங்கள் முழுப் பெயரை உள்ளிடவும்',
    cityCountry: 'நகரம், நாடு',
    generatingChart: 'ஜாதகம் உருவாக்குகிறது...',
    generateBirthChart: '🪬 ஜாதகம் உருவாக்கு',
    loadingBirthChart: 'உங்கள் வானியல் வரைபடத்தை வரைகிறது...',
    elementSign: '{element} ராசி • {ruler} ஆட்சி',
    natalChartReading: '🪬 ஜனன ஜாதக வாசிப்பு',
    fillNameDob: 'தயவுசெய்து குறைந்தபட்சம் உங்கள் பெயர் மற்றும் பிறந்த தேதியை நிரப்பவும்.',

    // Compatibility
    compatibilityTitle: '💕 பொருத்தம் சரிபார்ப்பு',
    compatibilityDesc: 'இரு ராசிகளுக்கிடையேயான பிரபஞ்ச வேதியியலைக் கண்டறியுங்கள்',
    person1Name: 'நபர் 1 பெயர் (விருப்பத்தேர்வு)',
    person2Name: 'நபர் 2 பெயர் (விருப்பத்தேர்வு)',
    firstPersonName: 'முதல் நபரின் பெயர்',
    secondPersonName: 'இரண்டாம் நபரின் பெயர்',
    selectSign1: 'ராசி 1 தேர்வு',
    selectSign2: 'ராசி 2 தேர்வு',
    selectingPerson1: '👆 நபர் 1 க்கான தேர்வு',
    selectingPerson2: '👆 நபர் 2 க்கான தேர்வு',
    checkingStars: 'நட்சத்திரங்களைச் சரிபார்க்கிறது...',
    checkCompatibility: '💕 {sign1} & {sign2} பொருத்தம் சரிபார்',
    loadingCompatibility: 'பிரபஞ்ச தொடர்பை பகுப்பாய்வு செய்கிறது...',
    compatibilityResult: '💕 {sign1} & {sign2} பொருத்தம்',
    selectBothSigns: 'தயவுசெய்து இரண்டு ராசிகளையும் தேர்ந்தெடுக்கவும்.',

    // Numerology
    numerologyTitle: '🔢 எண் கணிதம்',
    numerologyDesc: 'உங்கள் வாழ்க்கையில் எண்களின் மறைந்த அர்த்தத்தைக் கண்டறியுங்கள்',
    calculating: 'கணக்கிடுகிறது...',
    calculateNumerology: '🔢 எண் கணிதத்தைக் கணக்கிடு',
    loadingNumerology: 'உங்கள் விதியின் எண்களை விளக்குகிறது...',
    lifePathNumber: 'உங்கள் வாழ்க்கைப் பாதை எண்',
    masterNumber: '✨ முதன்மை எண் — நீங்கள் அசாதாரண திறமை கொண்டவர்!',
    uniqueFrequency: '✨ உங்கள் தனித்துவமான அதிர்வு அதிர்வெண்',
    numerologyResult: '🔢 {name} க்கான எண் கணித வாசிப்பு',
    enterNameDob: 'தயவுசெய்து உங்கள் பெயர் மற்றும் பிறந்த தேதியை உள்ளிடவும்.',

    // Tarot
    tarotTitle: '🃏 டாரோ வாசிப்பு',
    tarotDesc: 'கடந்த, நிகழ், எதிர்கால வழிகாட்டுதலுக்காக மூன்று அட்டைகளை எடுக்கவும்',
    tarotIntro: 'உங்கள் கேள்வி அல்லது நோக்கத்தில் கவனம் செலுத்தி, பின் உங்கள் அட்டைகளை எடுக்கவும். பொது வாழ்க்கை வாசிப்பிற்கு கேள்வியை காலியாக விடவும்.',
    yourQuestion: 'உங்கள் கேள்வி (விருப்பத்தேர்வு)',
    questionPlaceholder: 'எதைப் பற்றி வழிகாட்டுதல் வேண்டும்?',
    drawCards: '🃏 உங்கள் அட்டைகளை எடுக்கவும்',
    reversed: '(தலைகீழ்)',
    upright: '(நேராக)',
    loadingTarot: 'அட்டைகள் தங்கள் ஞானத்தை வெளிப்படுத்துகின்றன...',
    tarotResult: '🃏 உங்கள் டாரோ வாசிப்பு',
    drawNewCards: '🔄 புதிய அட்டைகளை எடுக்கவும்',

    // Transits
    transitsTitle: '🪐 கிரக சஞ்சாரம்',
    transitsDesc: 'தற்போதைய கிரக இயக்கங்கள் உங்கள் ராசியை எவ்வாறு பாதிக்கின்றன என்பதைக் கண்டறியவும்',
    scanningCosmos: 'பிரபஞ்சத்தை ஸ்கேன் செய்கிறது...',
    getTransits: '🪐 {sign} க்கான சஞ்சாரம் பெறு',
    loadingTransits: 'கிரக இயக்கங்களைக் கண்காணிக்கிறது...',
    transitsResult: '🪐 கிரக சஞ்சாரம் — {sign}',

    // Vedic
    vedicTitle: '🕉️ வேத ஜோதிடம்',
    vedicDesc: 'வானியல் ஞானத்தின் பண்டைய இந்திய அறிவியலை ஆராயுங்கள்',
    consultingJyotish: 'ஜோதிடரை ஆலோசிக்கிறது...',
    getVedicReading: '🕉️ வேத வாசிப்பு பெறு',
    loadingVedic: 'பண்டைய வேத ஞானத்தை ஆலோசிக்கிறது...',
    vedicResult: '🕉️ {name} க்கான வேத ஜோதிட வாசிப்பு',

    // Chinese Zodiac
    chineseTitle: '🐉 சீன ராசி',
    chineseDesc: 'உங்கள் சீன ராசி விலங்கு மற்றும் அதன் அர்த்தத்தைக் கண்டறியுங்கள்',
    birthYear: 'பிறந்த ஆண்டு *',
    yearPlaceholder: 'எ.கா. 1995',
    discovering: 'கண்டறிகிறது...',
    discoverChinese: '🐉 எனது சீன ராசியைக் கண்டறி',
    yearOfThe: '{animal} ஆண்டு',
    bornIn: '{year} இல் பிறந்தவர்',
    loadingChinese: 'சீன ராசியை ஆராய்கிறது...',
    chineseResult: '🐉 {animal} ஆண்டு — {year}',
    invalidYear: 'தயவுசெய்து சரியான பிறந்த ஆண்டை (1900-2030) உள்ளிடவும்.',

    // Ask Astrologer
    askTitle: '✨ AI ஜோதிடரிடம் கேள்',
    askDesc: 'உங்கள் தனிப்பட்ட பிரபஞ்ச ஆலோசகர் — AI மூலம் இயக்கப்படுகிறது',
    askGreeting: '✨ வணக்கம், பிரபஞ்ச தேடுபவரே! நான் உங்கள் AI ஜோதிடர். ராசிகள், ஜாதகம், கிரக சஞ்சாரம், காதல் பொருத்தம், எண் கணிதம், டாரோ அல்லது எந்த வானியல் விஷயம் பற்றியும் என்னிடம் கேளுங்கள். இன்று எதை ஆராய விரும்புகிறீர்கள்?',
    askLoading: '✨ நட்சத்திரங்கள் உங்களுக்கான பதிலை சீரமைக்கின்றன...',
    askPlaceholder: 'ஜோதிடம் பற்றி எதுவும் கேள்...',
    sugQ1: 'புதன் வக்ரம் என்றால் என்ன?',
    sugQ2: 'எனது லக்னத்தை எப்படிக் கண்டறிவது?',
    sugQ3: 'மிகவும் பொருத்தமான ராசி ஜோடிகள் எவை?',
    sugQ4: 'ஜோதிடத்தில் 12 பாவங்களை விளக்கவும்',
    sugQ5: 'கிராண்ட் ட்ரைன் என்றால் என்ன?',
    sugQ6: 'சனி பெயர்ச்சி என்னை எப்படி பாதிக்கும்?',

    // Common
    apiKeyError: 'தயவுசெய்து முதலில் உங்கள் OpenRouter API விசையை இணைக்கவும்.',
    apiKeyChat: '🔑 தயவுசெய்து முதலில் மேலே உள்ள அமைப்பைப் பயன்படுத்தி உங்கள் OpenRouter API விசையை இணைக்கவும்.',
  },

  kn: {
    // Navbar
    navHome: 'ಮುಖಪುಟ',
    navHoroscope: 'ರಾಶಿಭವಿಷ್ಯ',
    navBirthChart: 'ಜಾತಕ',
    navCompatibility: 'ಹೊಂದಾಣಿಕೆ',
    navNumerology: 'ಸಂಖ್ಯಾಶಾಸ್ತ್ರ',
    navTarot: 'ಟ್ಯಾರೋ',
    navVedic: 'ವೈದಿಕ',
    navAskAI: 'AI ಅನ್ನು ಕೇಳಿ',
    navMoonPhase: 'ಚಂದ್ರ ಕಲೆ',
    navNakshatra: 'ನಕ್ಷತ್ರ',
    navMuhurat: 'ಮುಹೂರ್ತ',
    navRemedies: 'ಪರಿಹಾರಗಳು',
    navPalmReading: 'ಹಸ್ತರೇಖೆ',
    navTemples: 'ದೇವಾಲಯಗಳು',
    navMore: 'ಇನ್ನಷ್ಟು',
    navKundali: 'ಕುಂಡಲಿ',
    navProfile: 'ಪ್ರೊಫೈಲ್',

    // Footer
    footerBrand: '🕉️ AstroA2Z — AI-ಚಾಲಿತ ಜ್ಯೋತಿಷ್ಯ 🪷',
    footerPowered: 'AI ನಿಂದ ಚಾಲಿತ • ವೈದಿಕ ಜ್ಞಾನದಲ್ಲಿ ಬೇರೂರಿದೆ • ಮಾರ್ಗದರ್ಶನ ಮತ್ತು ಮನರಂಜನೆಗಾಗಿ',

    // Loading
    defaultLoading: 'ನಕ್ಷತ್ರಗಳನ್ನು ಸಂಪರ್ಕಿಸಲಾಗುತ್ತಿದೆ...',

    // Home
    heroTagline: 'ನಿಮ್ಮ ಸಂಪೂರ್ಣ AI-ಚಾಲಿತ ಜ್ಯೋತಿಷ್ಯ ಸಂಗಾತಿ. ವೈಯಕ್ತಿಕ ರಾಶಿಭವಿಷ್ಯ, ಕುಂಡಲಿ, ಹೊಂದಾಣಿಕೆ ವಾಚನಗಳು ಮತ್ತು ವೈದಿಕ ಜ್ಞಾನದೊಂದಿಗೆ ನಿಮ್ಮ ಬ್ರಹ್ಮಾಂಡದ ನೀಲನಕ್ಷೆಯನ್ನು ಅನ್ವೇಷಿಸಿ.',
    heroBtn1: '🪷 ನಿಮ್ಮ ರಾಶಿಭವಿಷ್ಯ ಪಡೆಯಿರಿ',
    heroBtn2: '🪬 ಕುಂಡಲಿ',
    heroBtn3: '✨ AI ಜ್ಯೋತಿಷಿಯನ್ನು ಕೇಳಿ',
    exploreTitle: 'ಬ್ರಹ್ಮಾಂಡದ ಜ್ಞಾನವನ್ನು ಅನ್ವೇಷಿಸಿ',
    exploreDesc: 'ನಿಮ್ಮ ಜ್ಯೋತಿಷ್ಯ ಪ್ರಯಾಣಕ್ಕೆ ಬೇಕಾದ ಎಲ್ಲವೂ, AI ಮತ್ತು ವೈದಿಕ ಜ್ಞಾನದಿಂದ ಚಾಲಿತ',
    zodiacTitle: '12 ರಾಶಿಗಳು',
    zodiacDesc: 'ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ರಾಶಿಭವಿಷ್ಯ ಪಡೆಯಲು ನಿಮ್ಮ ರಾಶಿಯನ್ನು ಕ್ಲಿಕ್ ಮಾಡಿ',
    featureDailyHoroscope: 'ದೈನಂದಿನ ರಾಶಿಭವಿಷ್ಯ',
    featureDailyHoroscopeDesc: 'AI ಮೂಲಕ ನಿಮ್ಮ ದೈನಂದಿನ, ಸಾಪ್ತಾಹಿಕ, ಮಾಸಿಕ ಮತ್ತು ವಾರ್ಷಿಕ ರಾಶಿಭವಿಷ್ಯ ಪಡೆಯಿರಿ',
    featureBirthChart: 'ಜಾತಕ',
    featureBirthChartDesc: 'ಗ್ರಹ ಸ್ಥಾನಗಳೊಂದಿಗೆ ನಿಮ್ಮ ಸಂಪೂರ್ಣ ಜಾತಕವನ್ನು ರಚಿಸಿ',
    featureCompatibility: 'ಹೊಂದಾಣಿಕೆ',
    featureCompatibilityDesc: 'ಯಾವುದೇ ಎರಡು ರಾಶಿಗಳ ನಡುವಿನ ಪ್ರೀತಿಯ ಹೊಂದಾಣಿಕೆಯನ್ನು ಪರಿಶೀಲಿಸಿ',
    featureNumerology: 'ಸಂಖ್ಯಾಶಾಸ್ತ್ರ',
    featureNumerologyDesc: 'ನಿಮ್ಮ ಜೀವನಪಥ ಸಂಖ್ಯೆ ಮತ್ತು ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ಪ್ರೊಫೈಲ್ ಅನ್ನು ಅನ್ವೇಷಿಸಿ',
    featureTarotReading: 'ಟ್ಯಾರೋ ವಾಚನ',
    featureTarotReadingDesc: 'ಮಾರ್ಗದರ್ಶನಕ್ಕಾಗಿ AI-ಅರ್ಥೈಸಿದ ಟ್ಯಾರೋ ಕಾರ್ಡ್ ವಾಚನಗಳನ್ನು ಪಡೆಯಿರಿ',
    featureVedicAstrology: 'ವೈದಿಕ ಜ್ಯೋತಿಷ್ಯ',
    featureVedicAstrologyDesc: 'ಪ್ರಾಚೀನ ಜ್ಯೋತಿಷ್ಯ — ನಕ್ಷತ್ರ, ದಶೆ, ಗ್ರಹ ದೋಷ ಮತ್ತು ವೈದಿಕ ಪರಿಹಾರಗಳನ್ನು ಅನ್ವೇಷಿಸಿ',
    featurePlanetaryTransits: 'ಗ್ರಹ ಸಂಚಾರ',
    featurePlanetaryTransitsDesc: 'ಪ್ರಸ್ತುತ ಗ್ರಹ ಚಲನೆಗಳು ಮತ್ತು ನಿಮ್ಮ ರಾಶಿಯ ಮೇಲೆ ಅವುಗಳ ಪರಿಣಾಮಗಳು',
    featureChineseZodiac: 'ಚೀನೀ ರಾಶಿಚಕ್ರ',
    featureChineseZodiacDesc: 'ನಿಮ್ಮ ಚೀನೀ ರಾಶಿಯ ಪ್ರಾಣಿ ಮತ್ತು ಅಂಶವನ್ನು ಅನ್ವೇಷಿಸಿ',
    featureAskAstrologer: 'ಜ್ಯೋತಿಷಿಯನ್ನು ಕೇಳಿ',
    featureAskAstrologerDesc: 'ಯಾವುದೇ ಬ್ರಹ್ಮಾಂಡದ ವಿಷಯದ ಬಗ್ಗೆ ನಮ್ಮ AI ಜ್ಯೋತಿಷಿಯೊಂದಿಗೆ ಚಾಟ್ ಮಾಡಿ',

    // Horoscope
    horoscopeTitle: '🔮 ರಾಶಿಭವಿಷ್ಯ',
    horoscopeDesc: 'ನಿಮ್ಮ ರಾಶಿಯನ್ನು ಆಯ್ಕೆ ಮಾಡಿ ಮತ್ತು ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ರಾಶಿಭವಿಷ್ಯ ಪಡೆಯಿರಿ',
    daily: 'ದೈನಂದಿನ',
    weekly: 'ಸಾಪ್ತಾಹಿಕ',
    monthly: 'ಮಾಸಿಕ',
    yearly: 'ವಾರ್ಷಿಕ',
    readingStars: 'ನಕ್ಷತ್ರಗಳನ್ನು ಓದಲಾಗುತ್ತಿದೆ...',
    getHoroscope: '{sign} ಗಾಗಿ {period} ರಾಶಿಭವಿಷ್ಯ ಪಡೆಯಿರಿ',
    loadingHoroscope: '{sign} ಗಾಗಿ {period} ಬ್ರಹ್ಮಾಂಡ ಶಕ್ತಿಗಳನ್ನು ಓದಲಾಗುತ್ತಿದೆ...',
    horoscopeResult: '🔮 {period} ರಾಶಿಭವಿಷ್ಯ — {sign}',

    // Birth Chart
    birthChartTitle: '🪬 ಕುಂಡಲಿ / ಜಾತಕ',
    birthChartDesc: 'ನಿಮ್ಮ ಸಂಪೂರ್ಣ ಜಾತಕ ವಾಚನಕ್ಕಾಗಿ ನಿಮ್ಮ ಜನ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ',
    fullName: 'ಪೂರ್ಣ ಹೆಸರು *',
    dateOfBirth: 'ಜನ್ಮ ದಿನಾಂಕ *',
    timeOfBirth: 'ಜನ್ಮ ಸಮಯ',
    placeOfBirth: 'ಜನ್ಮ ಸ್ಥಳ',
    enterFullName: 'ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ',
    cityCountry: 'ನಗರ, ದೇಶ',
    generatingChart: 'ಜಾತಕ ರಚಿಸಲಾಗುತ್ತಿದೆ...',
    generateBirthChart: '🪬 ಜಾತಕ ರಚಿಸಿ',
    loadingBirthChart: 'ನಿಮ್ಮ ಆಕಾಶ ನೀಲನಕ್ಷೆಯನ್ನು ಮ್ಯಾಪಿಂಗ್ ಮಾಡಲಾಗುತ್ತಿದೆ...',
    elementSign: '{element} ರಾಶಿ • {ruler} ಆಳ್ವಿಕೆ',
    natalChartReading: '🪬 ಜನ್ಮ ಜಾತಕ ವಾಚನ',
    fillNameDob: 'ದಯವಿಟ್ಟು ಕನಿಷ್ಠ ನಿಮ್ಮ ಹೆಸರು ಮತ್ತು ಜನ್ಮ ದಿನಾಂಕವನ್ನು ಭರ್ತಿ ಮಾಡಿ.',

    // Compatibility
    compatibilityTitle: '💕 ಹೊಂದಾಣಿಕೆ ಪರಿಶೀಲನೆ',
    compatibilityDesc: 'ಎರಡು ರಾಶಿಗಳ ನಡುವಿನ ಬ್ರಹ್ಮಾಂಡದ ರಸಾಯನಶಾಸ್ತ್ರವನ್ನು ಅನ್ವೇಷಿಸಿ',
    person1Name: 'ವ್ಯಕ್ತಿ 1 ಹೆಸರು (ಐಚ್ಛಿಕ)',
    person2Name: 'ವ್ಯಕ್ತಿ 2 ಹೆಸರು (ಐಚ್ಛಿಕ)',
    firstPersonName: 'ಮೊದಲ ವ್ಯಕ್ತಿಯ ಹೆಸರು',
    secondPersonName: 'ಎರಡನೇ ವ್ಯಕ್ತಿಯ ಹೆಸರು',
    selectSign1: 'ರಾಶಿ 1 ಆಯ್ಕೆಮಾಡಿ',
    selectSign2: 'ರಾಶಿ 2 ಆಯ್ಕೆಮಾಡಿ',
    selectingPerson1: '👆 ವ್ಯಕ್ತಿ 1 ಗಾಗಿ ಆಯ್ಕೆ',
    selectingPerson2: '👆 ವ್ಯಕ್ತಿ 2 ಗಾಗಿ ಆಯ್ಕೆ',
    checkingStars: 'ನಕ್ಷತ್ರಗಳನ್ನು ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ...',
    checkCompatibility: '💕 {sign1} & {sign2} ಹೊಂದಾಣಿಕೆ ಪರಿಶೀಲಿಸಿ',
    loadingCompatibility: 'ಬ್ರಹ್ಮಾಂಡದ ಸಂಪರ್ಕವನ್ನು ವಿಶ್ಲೇಷಿಸಲಾಗುತ್ತಿದೆ...',
    compatibilityResult: '💕 {sign1} & {sign2} ಹೊಂದಾಣಿಕೆ',
    selectBothSigns: 'ದಯವಿಟ್ಟು ಎರಡೂ ರಾಶಿಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ.',

    // Numerology
    numerologyTitle: '🔢 ಸಂಖ್ಯಾಶಾಸ್ತ್ರ',
    numerologyDesc: 'ನಿಮ್ಮ ಜೀವನದಲ್ಲಿ ಸಂಖ್ಯೆಗಳ ಗುಪ್ತ ಅರ್ಥವನ್ನು ಅನ್ವೇಷಿಸಿ',
    calculating: 'ಲೆಕ್ಕಾಚಾರ ಮಾಡಲಾಗುತ್ತಿದೆ...',
    calculateNumerology: '🔢 ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ಲೆಕ್ಕಹಾಕಿ',
    loadingNumerology: 'ನಿಮ್ಮ ವಿಧಿಯ ಸಂಖ್ಯೆಗಳನ್ನು ಡಿಕೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...',
    lifePathNumber: 'ನಿಮ್ಮ ಜೀವನಪಥ ಸಂಖ್ಯೆ',
    masterNumber: '✨ ಮಾಸ್ಟರ್ ಸಂಖ್ಯೆ — ನೀವು ಅಸಾಧಾರಣ ಸಾಮರ್ಥ್ಯ ಹೊಂದಿರುವಿರಿ!',
    uniqueFrequency: '✨ ನಿಮ್ಮ ವಿಶಿಷ್ಟ ಕಂಪನ ಆವರ್ತನ',
    numerologyResult: '🔢 {name} ಗಾಗಿ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ವಾಚನ',
    enterNameDob: 'ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹೆಸರು ಮತ್ತು ಜನ್ಮ ದಿನಾಂಕವನ್ನು ನಮೂದಿಸಿ.',

    // Tarot
    tarotTitle: '🃏 ಟ್ಯಾರೋ ವಾಚನ',
    tarotDesc: 'ಭೂತ, ವರ್ತಮಾನ ಮತ್ತು ಭವಿಷ್ಯದ ಮಾರ್ಗದರ್ಶನಕ್ಕಾಗಿ ಮೂರು ಕಾರ್ಡ್‌ಗಳನ್ನು ಎಳೆಯಿರಿ',
    tarotIntro: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆ ಅಥವಾ ಉದ್ದೇಶದ ಮೇಲೆ ಗಮನ ಕೇಂದ್ರೀಕರಿಸಿ, ನಂತರ ನಿಮ್ಮ ಕಾರ್ಡ್‌ಗಳನ್ನು ಎಳೆಯಿರಿ. ಸಾಮಾನ್ಯ ಜೀವನ ವಾಚನಕ್ಕೆ ಪ್ರಶ್ನೆಯನ್ನು ಖಾಲಿ ಬಿಡಿ.',
    yourQuestion: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆ (ಐಚ್ಛಿಕ)',
    questionPlaceholder: 'ಯಾವುದರ ಬಗ್ಗೆ ಮಾರ್ಗದರ್ಶನ ಬಯಸುತ್ತೀರಿ?',
    drawCards: '🃏 ನಿಮ್ಮ ಕಾರ್ಡ್‌ಗಳನ್ನು ಎಳೆಯಿರಿ',
    reversed: '(ತಲೆಕೆಳಗಾದ)',
    upright: '(ನೇರ)',
    loadingTarot: 'ಕಾರ್ಡ್‌ಗಳು ತಮ್ಮ ಜ್ಞಾನವನ್ನು ಬಹಿರಂಗಪಡಿಸುತ್ತಿವೆ...',
    tarotResult: '🃏 ನಿಮ್ಮ ಟ್ಯಾರೋ ವಾಚನ',
    drawNewCards: '🔄 ಹೊಸ ಕಾರ್ಡ್‌ಗಳನ್ನು ಎಳೆಯಿರಿ',

    // Transits
    transitsTitle: '🪐 ಗ್ರಹ ಸಂಚಾರ',
    transitsDesc: 'ಪ್ರಸ್ತುತ ಗ್ರಹ ಚಲನೆಗಳು ನಿಮ್ಮ ರಾಶಿಯನ್ನು ಹೇಗೆ ಪ್ರಭಾವಿಸುತ್ತವೆ ಎಂಬುದನ್ನು ಅನ್ವೇಷಿಸಿ',
    scanningCosmos: 'ಬ್ರಹ್ಮಾಂಡವನ್ನು ಸ್ಕ್ಯಾನ್ ಮಾಡಲಾಗುತ್ತಿದೆ...',
    getTransits: '🪐 {sign} ಗಾಗಿ ಸಂಚಾರ ಪಡೆಯಿರಿ',
    loadingTransits: 'ಗ್ರಹ ಚಲನೆಗಳನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಲಾಗುತ್ತಿದೆ...',
    transitsResult: '🪐 ಗ್ರಹ ಸಂಚಾರ — {sign}',

    // Vedic
    vedicTitle: '🕉️ ವೈದಿಕ ಜ್ಯೋತಿಷ್ಯ',
    vedicDesc: 'ಆಕಾಶ ಜ್ಞಾನದ ಪ್ರಾಚೀನ ಭಾರತೀಯ ವಿಜ್ಞಾನವನ್ನು ಅನ್ವೇಷಿಸಿ',
    consultingJyotish: 'ಜ್ಯೋತಿಷಿಯನ್ನು ಸಂಪರ್ಕಿಸಲಾಗುತ್ತಿದೆ...',
    getVedicReading: '🕉️ ವೈದಿಕ ವಾಚನ ಪಡೆಯಿರಿ',
    loadingVedic: 'ಪ್ರಾಚೀನ ವೈದಿಕ ಜ್ಞಾನವನ್ನು ಸಂಪರ್ಕಿಸಲಾಗುತ್ತಿದೆ...',
    vedicResult: '🕉️ {name} ಗಾಗಿ ವೈದಿಕ ಜ್ಯೋತಿಷ್ಯ ವಾಚನ',

    // Chinese Zodiac
    chineseTitle: '🐉 ಚೀನೀ ರಾಶಿಚಕ್ರ',
    chineseDesc: 'ನಿಮ್ಮ ಚೀನೀ ರಾಶಿಯ ಪ್ರಾಣಿ ಮತ್ತು ಅದರ ಅರ್ಥವನ್ನು ಅನ್ವೇಷಿಸಿ',
    birthYear: 'ಜನ್ಮ ವರ್ಷ *',
    yearPlaceholder: 'ಉದಾ. 1995',
    discovering: 'ಅನ್ವೇಷಿಸಲಾಗುತ್ತಿದೆ...',
    discoverChinese: '🐉 ನನ್ನ ಚೀನೀ ರಾಶಿಚಕ್ರವನ್ನು ಅನ್ವೇಷಿಸಿ',
    yearOfThe: '{animal} ವರ್ಷ',
    bornIn: '{year} ರಲ್ಲಿ ಜನಿಸಿದರು',
    loadingChinese: 'ಚೀನೀ ರಾಶಿಚಕ್ರವನ್ನು ಅನ್ವೇಷಿಸಲಾಗುತ್ತಿದೆ...',
    chineseResult: '🐉 {animal} ವರ್ಷ — {year}',
    invalidYear: 'ದಯವಿಟ್ಟು ಮಾನ್ಯ ಜನ್ಮ ವರ್ಷ (1900-2030) ಅನ್ನು ನಮೂದಿಸಿ.',

    // Ask Astrologer
    askTitle: '✨ AI ಜ್ಯೋತಿಷಿಯನ್ನು ಕೇಳಿ',
    askDesc: 'ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಬ್ರಹ್ಮಾಂಡ ಸಲಹೆಗಾರ — AI ನಿಂದ ಚಾಲಿತ',
    askGreeting: '✨ ನಮಸ್ಕಾರ, ಬ್ರಹ್ಮಾಂಡ ಶೋಧಕರೇ! ನಾನು ನಿಮ್ಮ AI ಜ್ಯೋತಿಷಿ. ರಾಶಿಗಳು, ಜಾತಕ, ಗ್ರಹ ಸಂಚಾರ, ಪ್ರೀತಿ ಹೊಂದಾಣಿಕೆ, ಸಂಖ್ಯಾಶಾಸ್ತ್ರ, ಟ್ಯಾರೋ ಅಥವಾ ಯಾವುದೇ ಆಕಾಶ ವಿಷಯದ ಬಗ್ಗೆ ನನ್ನನ್ನು ಕೇಳಿ. ಇಂದು ನೀವು ಏನು ಅನ್ವೇಷಿಸಲು ಬಯಸುತ್ತೀರಿ?',
    askLoading: '✨ ನಕ್ಷತ್ರಗಳು ನಿಮಗಾಗಿ ಉತ್ತರವನ್ನು ಜೋಡಿಸುತ್ತಿವೆ...',
    askPlaceholder: 'ಜ್ಯೋತಿಷ್ಯದ ಬಗ್ಗೆ ಏನನ್ನಾದರೂ ಕೇಳಿ...',
    sugQ1: 'ಬುಧ ವಕ್ರ ಎಂದರೇನು?',
    sugQ2: 'ನನ್ನ ಲಗ್ನ ರಾಶಿಯನ್ನು ಹೇಗೆ ಕಂಡುಹಿಡಿಯುವುದು?',
    sugQ3: 'ಅತ್ಯಂತ ಹೊಂದಾಣಿಕೆಯ ರಾಶಿ ಜೋಡಿಗಳು ಯಾವುವು?',
    sugQ4: 'ಜ್ಯೋತಿಷ್ಯದಲ್ಲಿ 12 ಭಾವಗಳನ್ನು ವಿವರಿಸಿ',
    sugQ5: 'ಗ್ರ್ಯಾಂಡ್ ಟ್ರೈನ್ ಎಂದರೇನು?',
    sugQ6: 'ಶನಿ ಸಾಡೇಸಾತಿ ನನ್ನನ್ನು ಹೇಗೆ ಪ್ರಭಾವಿಸುತ್ತದೆ?',

    // Common
    apiKeyError: 'ದಯವಿಟ್ಟು ಮೊದಲು ನಿಮ್ಮ OpenRouter API ಕೀಯನ್ನು ಸಂಪರ್ಕಿಸಿ.',
    apiKeyChat: '🔑 ದಯವಿಟ್ಟು ಮೊದಲು ಮೇಲಿನ ಸೆಟಪ್ ಬಳಸಿ ನಿಮ್ಮ OpenRouter API ಕೀಯನ್ನು ಸಂಪರ್ಕಿಸಿ.',
  },

  ml: {
    // Navbar
    navHome: 'ഹോം',
    navHoroscope: 'രാശിഫലം',
    navBirthChart: 'ജാതകം',
    navCompatibility: 'പൊരുത്തം',
    navNumerology: 'സംഖ്യാശാസ്ത്രം',
    navTarot: 'ടാരോട്ട്',
    navVedic: 'വൈദിക',
    navAskAI: 'AI യോട് ചോദിക്കുക',
    navMoonPhase: 'ചന്ദ്രകല',
    navNakshatra: 'നക്ഷത്രം',
    navMuhurat: 'മുഹൂർത്തം',
    navRemedies: 'പരിഹാരങ്ങൾ',
    navPalmReading: 'കൈരേഖ',
    navTemples: 'ക്ഷേത്രങ്ങൾ',
    navMore: 'കൂടുതൽ',
    navKundali: 'കുണ്ഡലി',
    navProfile: 'പ്രൊഫൈൽ',

    // Footer
    footerBrand: '🕉️ AstroA2Z — AI-പ്രവർത്തിത ജ്യോതിഷം 🪷',
    footerPowered: 'AI ഉപയോഗിച്ച് പ്രവർത്തിക്കുന്നു • വൈദിക ജ്ഞാനത്തിൽ വേരൂന്നിയത് • മാർഗ്ഗനിർദേശത്തിനും വിനോദത്തിനും',

    // Loading
    defaultLoading: 'നക്ഷത്രങ്ങളെ ആലോചിക്കുന്നു...',

    // Home
    heroTagline: 'നിങ്ങളുടെ സമ്പൂർണ്ണ AI-പ്രവർത്തിത ജ്യോതിഷ സഹചാരി. വ്യക്തിഗത രാശിഫലങ്ങൾ, ജാതകം, പൊരുത്ത വായനകൾ, വൈദിക ജ്ഞാനം എന്നിവയോടെ നിങ്ങളുടെ കോസ്മിക് രൂപരേഖ കണ്ടെത്തുക.',
    heroBtn1: '🪷 നിങ്ങളുടെ രാശിഫലം നേടുക',
    heroBtn2: '🪬 ജാതകം',
    heroBtn3: '✨ AI ജ്യോത്സ്യനോട് ചോദിക്കുക',
    exploreTitle: 'കോസ്മിക് ജ്ഞാനം പര്യവേക്ഷണം ചെയ്യുക',
    exploreDesc: 'നിങ്ങളുടെ ജ്യോതിഷ യാത്രയ്ക്ക് ആവശ്യമായതെല്ലാം, AI യും വൈദിക അറിവും ഉപയോഗിച്ച് പ്രവർത്തിക്കുന്നു',
    zodiacTitle: '12 രാശികൾ',
    zodiacDesc: 'നിങ്ങളുടെ വ്യക്തിഗത രാശിഫലം ലഭിക്കാൻ നിങ്ങളുടെ രാശിയിൽ ക്ലിക്ക് ചെയ്യുക',
    featureDailyHoroscope: 'ദിവസേന രാശിഫലം',
    featureDailyHoroscopeDesc: 'AI ഉപയോഗിച്ച് നിങ്ങളുടെ ദിവസേന, ആഴ്ചതോറും, പ്രതിമാസ, വാർഷിക രാശിഫലം നേടുക',
    featureBirthChart: 'ജാതകം',
    featureBirthChartDesc: 'ഗ്രഹ സ്ഥാനങ്ങളോടെ നിങ്ങളുടെ സമ്പൂർണ്ണ ജാതകം നിർമ്മിക്കുക',
    featureCompatibility: 'പൊരുത്തം',
    featureCompatibilityDesc: 'ഏതെങ്കിലും രണ്ട് രാശികൾ തമ്മിലുള്ള പ്രണയ പൊരുത്തം പരിശോധിക്കുക',
    featureNumerology: 'സംഖ്യാശാസ്ത്രം',
    featureNumerologyDesc: 'നിങ്ങളുടെ ലൈഫ് പാത്ത് നമ്പറും സംഖ്യാശാസ്ത്ര പ്രൊഫൈലും കണ്ടെത്തുക',
    featureTarotReading: 'ടാരോട്ട് വായന',
    featureTarotReadingDesc: 'മാർഗ്ഗനിർദേശത്തിനായി AI-വ്യാഖ്യാനിച്ച ടാരോട്ട് കാർഡ് വായനകൾ നേടുക',
    featureVedicAstrology: 'വൈദിക ജ്യോതിഷം',
    featureVedicAstrologyDesc: 'പ്രാചീന ജ്യോതിഷം — നക്ഷത്രം, ദശ, ഗ്രഹ ദോഷം, വൈദിക പരിഹാരങ്ങൾ പര്യവേക്ഷണം ചെയ്യുക',
    featurePlanetaryTransits: 'ഗ്രഹ സഞ്ചാരം',
    featurePlanetaryTransitsDesc: 'നിലവിലെ ഗ്രഹ ചലനങ്ങളും നിങ്ങളുടെ രാശിയിലെ അവയുടെ സ്വാധീനവും',
    featureChineseZodiac: 'ചൈനീസ് രാശിചക്രം',
    featureChineseZodiacDesc: 'നിങ്ങളുടെ ചൈനീസ് രാശിയിലെ മൃഗവും മൂലകവും കണ്ടെത്തുക',
    featureAskAstrologer: 'ജ്യോത്സ്യനോട് ചോദിക്കുക',
    featureAskAstrologerDesc: 'ഏതെങ്കിലും കോസ്മിക് വിഷയത്തെക്കുറിച്ച് ഞങ്ങളുടെ AI ജ്യോത്സ്യനുമായി ചാറ്റ് ചെയ്യുക',

    // Horoscope
    horoscopeTitle: '🔮 രാശിഫലം',
    horoscopeDesc: 'നിങ്ങളുടെ രാശി തിരഞ്ഞെടുത്ത് നിങ്ങളുടെ വ്യക്തിഗത രാശിഫലം നേടുക',
    daily: 'ദിവസേന',
    weekly: 'ആഴ്ചതോറും',
    monthly: 'പ്രതിമാസം',
    yearly: 'വാർഷികം',
    readingStars: 'നക്ഷത്രങ്ങൾ വായിക്കുന്നു...',
    getHoroscope: '{sign} നുള്ള {period} രാശിഫലം നേടുക',
    loadingHoroscope: '{sign} നുള്ള {period} കോസ്മിക് ഊർജ്ജം വായിക്കുന്നു...',
    horoscopeResult: '🔮 {period} രാശിഫലം — {sign}',

    // Birth Chart
    birthChartTitle: '🪬 ജാതകം / ജനന ചാർട്ട്',
    birthChartDesc: 'നിങ്ങളുടെ സമ്പൂർണ്ണ ജാതക വായനയ്ക്ക് നിങ്ങളുടെ ജനന വിശദാംശങ്ങൾ നൽകുക',
    fullName: 'പൂർണ്ണ പേര് *',
    dateOfBirth: 'ജനന തീയതി *',
    timeOfBirth: 'ജനന സമയം',
    placeOfBirth: 'ജനന സ്ഥലം',
    enterFullName: 'നിങ്ങളുടെ പൂർണ്ണ പേര് നൽകുക',
    cityCountry: 'നഗരം, രാജ്യം',
    generatingChart: 'ജാതകം നിർമ്മിക്കുന്നു...',
    generateBirthChart: '🪬 ജാതകം നിർമ്മിക്കുക',
    loadingBirthChart: 'നിങ്ങളുടെ ആകാശ രൂപരേഖ മാപ്പ് ചെയ്യുന്നു...',
    elementSign: '{element} രാശി • {ruler} ഭരണം',
    natalChartReading: '🪬 ജനന ജാതക വായന',
    fillNameDob: 'ദയവായി കുറഞ്ഞത് നിങ്ങളുടെ പേരും ജനന തീയതിയും നൽകുക.',

    // Compatibility
    compatibilityTitle: '💕 പൊരുത്ത പരിശോധന',
    compatibilityDesc: 'രണ്ട് രാശികൾ തമ്മിലുള്ള കോസ്മിക് രസതന്ത്രം കണ്ടെത്തുക',
    person1Name: 'വ്യക്തി 1 പേര് (ഓപ്ഷണൽ)',
    person2Name: 'വ്യക്തി 2 പേര് (ഓപ്ഷണൽ)',
    firstPersonName: 'ആദ്യ വ്യക്തിയുടെ പേര്',
    secondPersonName: 'രണ്ടാമത്തെ വ്യക്തിയുടെ പേര്',
    selectSign1: 'രാശി 1 തിരഞ്ഞെടുക്കുക',
    selectSign2: 'രാശി 2 തിരഞ്ഞെടുക്കുക',
    selectingPerson1: '👆 വ്യക്തി 1 നായി തിരഞ്ഞെടുക്കുന്നു',
    selectingPerson2: '👆 വ്യക്തി 2 നായി തിരഞ്ഞെടുക്കുന്നു',
    checkingStars: 'നക്ഷത്രങ്ങൾ പരിശോധിക്കുന്നു...',
    checkCompatibility: '💕 {sign1} & {sign2} പൊരുത്തം പരിശോധിക്കുക',
    loadingCompatibility: 'കോസ്മിക് ബന്ധം വിശകലനം ചെയ്യുന്നു...',
    compatibilityResult: '💕 {sign1} & {sign2} പൊരുത്തം',
    selectBothSigns: 'ദയവായി രണ്ട് രാശികളും തിരഞ്ഞെടുക്കുക.',

    // Numerology
    numerologyTitle: '🔢 സംഖ്യാശാസ്ത്രം',
    numerologyDesc: 'നിങ്ങളുടെ ജീവിതത്തിലെ സംഖ്യകളുടെ മറഞ്ഞിരിക്കുന്ന അർത്ഥം കണ്ടെത്തുക',
    calculating: 'കണക്കാക്കുന്നു...',
    calculateNumerology: '🔢 സംഖ്യാശാസ്ത്രം കണക്കാക്കുക',
    loadingNumerology: 'നിങ്ങളുടെ വിധിയുടെ സംഖ്യകൾ ഡീകോഡ് ചെയ്യുന്നു...',
    lifePathNumber: 'നിങ്ങളുടെ ലൈഫ് പാത്ത് നമ്പർ',
    masterNumber: '✨ മാസ്റ്റർ നമ്പർ — നിങ്ങൾക്ക് അസാധാരണ കഴിവുണ്ട്!',
    uniqueFrequency: '✨ നിങ്ങളുടെ അദ്വിതീയ വൈബ്രേഷണൽ ഫ്രീക്വൻസി',
    numerologyResult: '🔢 {name} നുള്ള സംഖ്യാശാസ്ത്ര വായന',
    enterNameDob: 'ദയവായി നിങ്ങളുടെ പേരും ജനന തീയതിയും നൽകുക.',

    // Tarot
    tarotTitle: '🃏 ടാരോട്ട് വായന',
    tarotDesc: 'ഭൂത, വർത്തമാന, ഭാവി മാർഗ്ഗനിർദേശത്തിനായി മൂന്ന് കാർഡുകൾ വരയ്ക്കുക',
    tarotIntro: 'നിങ്ങളുടെ ചോദ്യത്തിലോ ഉദ്ദേശ്യത്തിലോ ശ്രദ്ധ കേന്ദ്രീകരിക്കുക, തുടർന്ന് നിങ്ങളുടെ കാർഡുകൾ വരയ്ക്കുക. പൊതുവായ ജീവിത വായനയ്ക്കായി ചോദ്യം ശൂന്യമായി വിടുക.',
    yourQuestion: 'നിങ്ങളുടെ ചോദ്യം (ഓപ്ഷണൽ)',
    questionPlaceholder: 'എന്തിനെക്കുറിച്ച് മാർഗ്ഗനിർദേശം വേണം?',
    drawCards: '🃏 നിങ്ങളുടെ കാർഡുകൾ വരയ്ക്കുക',
    reversed: '(തലകീഴായ)',
    upright: '(നേരെയുള്ള)',
    loadingTarot: 'കാർഡുകൾ അവയുടെ ജ്ഞാനം വെളിപ്പെടുത്തുന്നു...',
    tarotResult: '🃏 നിങ്ങളുടെ ടാരോട്ട് വായന',
    drawNewCards: '🔄 പുതിയ കാർഡുകൾ വരയ്ക്കുക',

    // Transits
    transitsTitle: '🪐 ഗ്രഹ സഞ്ചാരം',
    transitsDesc: 'നിലവിലെ ഗ്രഹ ചലനങ്ങൾ നിങ്ങളുടെ രാശിയെ എങ്ങനെ ബാധിക്കുന്നുവെന്ന് കണ്ടെത്തുക',
    scanningCosmos: 'പ്രപഞ്ചം സ്കാൻ ചെയ്യുന്നു...',
    getTransits: '🪐 {sign} നുള്ള സഞ്ചാരം നേടുക',
    loadingTransits: 'ഗ്രഹ ചലനങ്ങൾ ട്രാക്ക് ചെയ്യുന്നു...',
    transitsResult: '🪐 ഗ്രഹ സഞ്ചാരം — {sign}',

    // Vedic
    vedicTitle: '🕉️ വൈദിക ജ്യോതിഷം',
    vedicDesc: 'ആകാശ ജ്ഞാനത്തിന്റെ പ്രാചീന ഇന്ത്യൻ ശാസ്ത്രം പര്യവേക്ഷണം ചെയ്യുക',
    consultingJyotish: 'ജ്യോത്സ്യനെ സമീപിക്കുന്നു...',
    getVedicReading: '🕉️ വൈദിക വായന നേടുക',
    loadingVedic: 'പ്രാചീന വൈദിക ജ്ഞാനത്തെ സമീപിക്കുന്നു...',
    vedicResult: '🕉️ {name} നുള്ള വൈദിക ജ്യോതിഷ വായന',

    // Chinese Zodiac
    chineseTitle: '🐉 ചൈനീസ് രാശിചക്രം',
    chineseDesc: 'നിങ്ങളുടെ ചൈനീസ് രാശിയിലെ മൃഗവും അതിന്റെ അർത്ഥവും കണ്ടെത്തുക',
    birthYear: 'ജനന വർഷം *',
    yearPlaceholder: 'ഉദാ. 1995',
    discovering: 'കണ്ടെത്തുന്നു...',
    discoverChinese: '🐉 എന്റെ ചൈനീസ് രാശിചക്രം കണ്ടെത്തുക',
    yearOfThe: '{animal} വർഷം',
    bornIn: '{year} ൽ ജനിച്ചു',
    loadingChinese: 'ചൈനീസ് രാശിചക്രം പര്യവേക്ഷണം ചെയ്യുന്നു...',
    chineseResult: '🐉 {animal} വർഷം — {year}',
    invalidYear: 'ദയവായി സാധുവായ ജനന വർഷം (1900-2030) നൽകുക.',

    // Ask Astrologer
    askTitle: '✨ AI ജ്യോത്സ്യനോട് ചോദിക്കുക',
    askDesc: 'നിങ്ങളുടെ വ്യക്തിഗത കോസ്മിക് ഉപദേശകൻ — AI ഉപയോഗിച്ച് പ്രവർത്തിക്കുന്നു',
    askGreeting: '✨ നമസ്കാരം, കോസ്മിക് അന്വേഷകൻ! ഞാൻ നിങ്ങളുടെ AI ജ്യോത്സ്യനാണ്. രാശികൾ, ജാതകം, ഗ്രഹ സഞ്ചാരം, പ്രണയ പൊരുത്തം, സംഖ്യാശാസ്ത്രം, ടാരോട്ട് അല്ലെങ്കിൽ ഏതെങ്കിലും ആകാശ വിഷയത്തെക്കുറിച്ച് എന്നോട് ചോദിക്കുക. ഇന്ന് നിങ്ങൾ എന്താണ് പര്യവേക്ഷണം ചെയ്യാൻ ആഗ്രഹിക്കുന്നത്?',
    askLoading: '✨ നക്ഷത്രങ്ങൾ നിങ്ങൾക്കായി ഒരു ഉത്തരം ക്രമീകരിക്കുന്നു...',
    askPlaceholder: 'ജ്യോതിഷത്തെക്കുറിച്ച് എന്തെങ്കിലും ചോദിക്കുക...',
    sugQ1: 'ബുധൻ വക്രി എന്നാൽ എന്താണ്?',
    sugQ2: 'എന്റെ ലഗ്ന രാശി എങ്ങനെ കണ്ടെത്താം?',
    sugQ3: 'ഏറ്റവും അനുയോജ്യമായ രാശി ജോഡികൾ ഏതാണ്?',
    sugQ4: 'ജ്യോതിഷത്തിലെ 12 ഭാവങ്ങൾ വിശദീകരിക്കുക',
    sugQ5: 'ഗ്രാൻഡ് ട്രൈൻ എന്നാൽ എന്താണ്?',
    sugQ6: 'ശനി സാഡേസാത്തി എന്നെ എങ്ങനെ ബാധിക്കും?',

    // Common
    apiKeyError: 'ദയവായി ആദ്യം നിങ്ങളുടെ OpenRouter API കീ കണക്റ്റ് ചെയ്യുക.',
    apiKeyChat: '🔑 ദയവായി ആദ്യം മുകളിലുള്ള സജ്ജീകരണം ഉപയോഗിച്ച് നിങ്ങളുടെ OpenRouter API കീ കണക്റ്റ് ചെയ്യുക.',
  },
};

// Available languages with display labels
export const LANGUAGES = [
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'hi', label: 'हिन्दी', short: 'हि' },
  { code: 'te', label: 'తెలుగు', short: 'తె' },
  { code: 'ta', label: 'தமிழ்', short: 'த' },
  { code: 'kn', label: 'ಕನ್ನಡ', short: 'ಕ' },
  { code: 'ml', label: 'മലയാളം', short: 'മ' },
];

// Helper: replace {key} placeholders in translation strings
function interpolate(str, params = {}) {
  return Object.entries(params).reduce(
    (result, [key, value]) => result.replace(new RegExp(`\\{${key}\\}`, 'g'), value),
    str
  );
}

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    const saved = localStorage.getItem('astroa2z-lang');
    return LANGUAGES.some(l => l.code === saved) ? saved : 'en';
  });

  const setLanguage = (code) => {
    if (!LANGUAGES.some(l => l.code === code)) return;
    setLanguageState(code);
    localStorage.setItem('astroa2z-lang', code);
  };

  // Cycle to the next language in LANGUAGES order
  const toggleLanguage = () => {
    const currentIndex = LANGUAGES.findIndex(l => l.code === language);
    const nextLang = LANGUAGES[(currentIndex + 1) % LANGUAGES.length];
    setLanguage(nextLang.code);
  };

  const t = (key, params) => {
    const str = translations[language]?.[key] || translations.en[key] || key;
    return params ? interpolate(str, params) : str;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
}
